export default {
  type: "Feature",
  properties: {
    name: "Буянт-Ухаа",
    location: [47.64641, 106.3031],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [107.033192667608, 48.0564826922225],
        [107.035499999725, 48.0418055558818],
        [107.002805555932, 47.9833055561066],
        [106.954222222977, 47.9730277782094],
        [106.931916665622, 47.9624999995753],
        [106.928027776761, 47.9618055556819],
        [106.928061319674, 47.9617712474451],
        [106.928097799774, 47.9617385337064],
        [106.928119772909, 47.9617217820346],
        [106.928172652146, 47.9616857102274],
        [106.928194432827, 47.961668347916],
        [106.928232522713, 47.9616323354639],
        [106.928254438292, 47.9616044906548],
        [106.928266988331, 47.9615785335226],
        [106.928277676773, 47.9615431559919],
        [106.928283232785, 47.9615124738216],
        [106.928286319258, 47.9614706382594],
        [106.928287202393, 47.9614187105051],
        [106.928282918022, 47.9613792779314],
        [106.928275056149, 47.9613493619835],
        [106.928260459253, 47.9613091874691],
        [106.928246147442, 47.9612743657195],
        [106.92823145162, 47.9612431889221],
        [106.928215889752, 47.9612146327491],
        [106.928199248696, 47.9611883248813],
        [106.928159464488, 47.9611360212105],
        [106.92813826297, 47.9611124688654],
        [106.928116218789, 47.9610906836881],
        [106.928084032952, 47.9610624260902],
        [106.928051530554, 47.9610372459722],
        [106.928018566803, 47.9610150354156],
        [106.927985084144, 47.9609957548503],
        [106.927921607296, 47.9609663479187],
        [106.927814818199, 47.9609239394883],
        [106.927742739336, 47.960898333991],
        [106.92771049954, 47.9608828395715],
        [106.927682295901, 47.9608624402495],
        [106.927651963567, 47.9608338292179],
        [106.92762229853, 47.9607986171625],
        [106.927581651872, 47.960754066547],
        [106.927544635776, 47.9607118370816],
        [106.927508062147, 47.9606815020497],
        [106.927486416365, 47.9606592150508],
        [106.927471047851, 47.9606392707857],
        [106.927462250682, 47.9606225676774],
        [106.927447757208, 47.9605849067681],
        [106.927417029173, 47.960521144835],
        [106.927393289769, 47.9604632707634],
        [106.927381431308, 47.9604217535611],
        [106.92737689243, 47.9603885182156],
        [106.927375056014, 47.9603456799093],
        [106.927375763781, 47.9603057275274],
        [106.927379219875, 47.9602670476862],
        [106.927383374743, 47.9602371515234],
        [106.927387986466, 47.9602169068848],
        [106.927394931931, 47.9601984114276],
        [106.92740547828, 47.9601782324395],
        [106.927451305034, 47.9601087139461],
        [106.927508037866, 47.9600207818337],
        [106.927582278699, 47.9599136815712],
        [106.927664148482, 47.9597985000008],
        [106.927720688859, 47.9597280471117],
        [106.927768227921, 47.9596757982995],
        [106.927812784832, 47.9596312737643],
        [106.927859512706, 47.9595900875126],
        [106.927946853964, 47.9595195114164],
        [106.928105187704, 47.9593930577435],
        [106.92832231822, 47.959227526729],
        [106.928428312317, 47.9591460409571],
        [106.928456931442, 47.959121558713],
        [106.92848056023, 47.95909869345],
        [106.928519392956, 47.9590560305115],
        [106.928545027231, 47.9590214299951],
        [106.928561638609, 47.9589933675499],
        [106.928571503272, 47.9589709906188],
        [106.928577485563, 47.9589487198076],
        [106.92858044703, 47.9589256081304],
        [106.928579900242, 47.9589074157447],
        [106.928574867636, 47.9588709464371],
        [106.928572308166, 47.9588343629156],
        [106.928569287343, 47.9588162847438],
        [106.928560265344, 47.9587912431214],
        [106.928538382141, 47.9587477644978],
        [106.928500216712, 47.9586746055486],
        [106.928473327882, 47.9586241364947],
        [106.928461872318, 47.958596686488],
        [106.928455379212, 47.9585708291805],
        [106.928448677465, 47.9585278694657],
        [106.928437949452, 47.9584660060014],
        [106.928436844185, 47.9584471912849],
        [106.928437961143, 47.9584304423111],
        [106.928442413687, 47.9584078927101],
        [106.928449383432, 47.9583856677644],
        [106.928458705805, 47.9583642971746],
        [106.928470193744, 47.9583441964276],
        [106.928495105864, 47.9583106346281],
        [106.928507848359, 47.9582974505669],
        [106.928521198794, 47.9582862036455],
        [106.928549296313, 47.9582682612713],
        [106.928583715166, 47.9582518252616],
        [106.928606645181, 47.958244110877],
        [106.92867492261, 47.9582264868629],
        [106.92874496271, 47.9581990521446],
        [106.928774431695, 47.958184621623],
        [106.928800398719, 47.9581696227299],
        [106.928838312338, 47.958143295077],
        [106.928865837888, 47.9581185295465],
        [106.928877710738, 47.9581037267057],
        [106.928888178846, 47.9580861161814],
        [106.928915424707, 47.9580224702609],
        [106.928937178408, 47.9579734518134],
        [106.9289577504, 47.9579217704734],
        [106.928983328918, 47.9578557107725],
        [106.928989314805, 47.9578350758281],
        [106.928992813168, 47.9578164328821],
        [106.928994147762, 47.9577804617989],
        [106.928989447905, 47.9577260240368],
        [106.928986121313, 47.9576832504817],
        [106.928979881816, 47.9576595254668],
        [106.928972384168, 47.957645379131],
        [106.928953493909, 47.9576171170364],
        [106.92893184363, 47.9575845840613],
        [106.928923297372, 47.9575676309415],
        [106.928919726165, 47.9575546006644],
        [106.928918167639, 47.9575397060926],
        [106.928920197409, 47.9574843591159],
        [106.928917975184, 47.9574215288805],
        [106.928920106578, 47.9573867529963],
        [106.928925535785, 47.95736138492],
        [106.928945075355, 47.957295869309],
        [106.928959773875, 47.957214679414],
        [106.928966458535, 47.9571637400147],
        [106.928967298502, 47.9571312295227],
        [106.928964110405, 47.9571002487775],
        [106.928957999512, 47.957071869771],
        [106.928944322622, 47.9570325864847],
        [106.928927007975, 47.9570009699189],
        [106.928905627493, 47.956974932747],
        [106.928871662797, 47.9569423826849],
        [106.928842904277, 47.9569192970879],
        [106.928769653597, 47.9568679152222],
        [106.928728225427, 47.9568370450936],
        [106.928707579691, 47.9568189642239],
        [106.928687150692, 47.9567966421513],
        [106.928672927913, 47.9567766942891],
        [106.928666653343, 47.9567639104262],
        [106.928661939997, 47.9567490967934],
        [106.928652117601, 47.9566937201391],
        [106.928633950397, 47.9566150042791],
        [106.928626082228, 47.9565656018211],
        [106.928621618893, 47.9565159304659],
        [106.928620458767, 47.9564780069545],
        [106.928622368927, 47.9564440089839],
        [106.928627497761, 47.956413216197],
        [106.92864094982, 47.956370406669],
        [106.928666281024, 47.9563125757648],
        [106.928685970781, 47.9562718454694],
        [106.928702673889, 47.956242925071],
        [106.928726798203, 47.9562100314678],
        [106.928767047361, 47.9561632820099],
        [106.92879956235, 47.9561273298125],
        [106.928828409004, 47.9560979732429],
        [106.928897032672, 47.9560373040784],
        [106.928920931256, 47.9560118325801],
        [106.928934398604, 47.9559938236561],
        [106.928944864914, 47.9559745925535],
        [106.928950779755, 47.9559578390831],
        [106.928952406628, 47.9559385171489],
        [106.928948919957, 47.9559078754481],
        [106.928943685902, 47.9558764972026],
        [106.92893616757, 47.9558509537585],
        [106.928927070028, 47.9558311578817],
        [106.928914164757, 47.9558100058272],
        [106.928872411932, 47.955756799237],
        [106.928841178478, 47.9557217544554],
        [106.928813438889, 47.955695891752],
        [106.928795050451, 47.9556820197095],
        [106.928772636648, 47.9556676260602],
        [106.928690180507, 47.9556217822195],
        [106.928580271662, 47.9555633910377],
        [106.928538233753, 47.9555386300038],
        [106.928480207695, 47.955498462684],
        [106.928425247427, 47.955454823981],
        [106.928355472627, 47.9553893362489],
        [106.928319430497, 47.9553543364335],
        [106.92830021918, 47.955333128621],
        [106.928275349328, 47.9552987484386],
        [106.928255061522, 47.9552624670892],
        [106.928242190425, 47.9552281615505],
        [106.928226638449, 47.955165336711],
        [106.928204239034, 47.9550844750685],
        [106.928199417769, 47.9550596357936],
        [106.928197063344, 47.9550372777482],
        [106.928197690171, 47.9549941606521],
        [106.928204146404, 47.9549419316249],
        [106.928214813263, 47.9548891288303],
        [106.928228850781, 47.9548439100185],
        [106.928245058363, 47.9548049855617],
        [106.928261700317, 47.9547743186799],
        [106.928289908453, 47.9547357728377],
        [106.928326161923, 47.954697055225],
        [106.92835411555, 47.9546726512219],
        [106.928398413456, 47.9546387063113],
        [106.928470932987, 47.9545874935181],
        [106.928536384746, 47.9545372645832],
        [106.928577539522, 47.9544999984762],
        [106.928606267465, 47.954468542889],
        [106.928628452841, 47.9544396269873],
        [106.928646172183, 47.9544096229058],
        [106.928668119238, 47.9543627790191],
        [106.928686070606, 47.9543198624717],
        [106.928706900703, 47.9542621394862],
        [106.928727503272, 47.95420473576],
        [106.92873541101, 47.954171194645],
        [106.928737925515, 47.9541376787109],
        [106.928736384976, 47.9541021402017],
        [106.928730502511, 47.9540662689432],
        [106.928719382394, 47.9540262437162],
        [106.928709424201, 47.9539942674215],
        [106.928699813146, 47.9539765786562],
        [106.928680829357, 47.953957446479],
        [106.928648634527, 47.9539345857126],
        [106.928622784414, 47.953919551746],
        [106.92858718565, 47.9539022901586],
        [106.928554424247, 47.9538885835913],
        [106.928504485793, 47.9538703489375],
        [106.928400445924, 47.9538363869398],
        [106.928325007193, 47.9538090844218],
        [106.928284739149, 47.9537906815947],
        [106.928256385324, 47.9537745279721],
        [106.928241057279, 47.953763248675],
        [106.928225784992, 47.9537495924698],
        [106.928186524189, 47.9537066615333],
        [106.928152677304, 47.9536638286228],
        [106.928107986395, 47.9535960898877],
        [106.928063874648, 47.9535270408403],
        [106.928039896924, 47.9534805800648],
        [106.928023777475, 47.9534344862126],
        [106.928007314486, 47.9533668562954],
        [106.927993602523, 47.9533048570336],
        [106.927989340636, 47.9532647886392],
        [106.927990849698, 47.9532244936156],
        [106.927997043329, 47.9531860970608],
        [106.92801289388, 47.9531358366496],
        [106.928014921851, 47.9531134687116],
        [106.928014132246, 47.953073919226],
        [106.928011565581, 47.9530049232387],
        [106.928003788244, 47.952959771876],
        [106.928002179357, 47.9529431829816],
        [106.928000996749, 47.9529172627215],
        [106.928004216322, 47.9529026775166],
        [106.928015729442, 47.9528853889496],
        [106.928034066619, 47.9528694610568],
        [106.928052032375, 47.952856146594],
        [106.928075694438, 47.9528417907161],
        [106.928132431766, 47.9528155529954],
        [106.928219073352, 47.9527837565652],
        [106.928273599247, 47.9527656136422],
        [106.928308410205, 47.9527569711573],
        [106.928342881219, 47.9527521525898],
        [106.928388407599, 47.9527488844535],
        [106.928451099339, 47.9527478322467],
        [106.928482572912, 47.9527499834251],
        [106.928509028269, 47.9527536004983],
        [106.928537725636, 47.9527601196838],
        [106.928567334015, 47.952769478029],
        [106.92859395125, 47.9527805981461],
        [106.928626076832, 47.9527971474704],
        [106.928676079138, 47.9528283404556],
        [106.928714321009, 47.9528553497946],
        [106.928746002326, 47.9528807691323],
        [106.92878633692, 47.9529242495545],
        [106.928804333253, 47.9529393455744],
        [106.928827986323, 47.952953055739],
        [106.928864582435, 47.9529700969924],
        [106.928910319256, 47.9529889548764],
        [106.928951486622, 47.9530023862512],
        [106.928990286972, 47.9530122680018],
        [106.929020006868, 47.9530171171463],
        [106.929055718946, 47.9530184499416],
        [106.929099747955, 47.9530157771564],
        [106.929149654933, 47.9530079125852],
        [106.929211164963, 47.9529920665307],
        [106.929269675755, 47.9529721141718],
        [106.929333508734, 47.9529443512009],
        [106.929387971678, 47.9529148327534],
        [106.92946936392, 47.9528626576856],
        [106.929536894013, 47.9528175692754],
        [106.929607652671, 47.9527670282758],
        [106.929676079388, 47.9527147650744],
        [106.929754064998, 47.9526514087356],
        [106.929793694523, 47.9526203317629],
        [106.929811357208, 47.9526028012783],
        [106.929830922859, 47.9525726928755],
        [106.92983594827, 47.9525579601818],
        [106.929841185023, 47.9525308312329],
        [106.929850929177, 47.9524750795613],
        [106.929863995427, 47.9524292006471],
        [106.929883044867, 47.9523852049133],
        [106.929910729597, 47.9523351090781],
        [106.929965506403, 47.952260752232],
        [106.929980942367, 47.9522366530991],
        [106.929999617688, 47.9522020327976],
        [106.930008333918, 47.9521786198475],
        [106.930011475249, 47.9521587061594],
        [106.930012391659, 47.9521289206132],
        [106.930010914972, 47.9520892407259],
        [106.930005633253, 47.9520719071928],
        [106.929997846024, 47.9520557122014],
        [106.929981937916, 47.9520354945425],
        [106.929948669296, 47.9520049229889],
        [106.929912732387, 47.9519738145399],
        [106.929878599518, 47.9519485292013],
        [106.929809120594, 47.9519080066492],
        [106.929706638351, 47.9518541426546],
        [106.929623018488, 47.9518142667151],
        [106.92958924265, 47.9517965581647],
        [106.929548515951, 47.9517719275325],
        [106.929504480647, 47.9517423964945],
        [106.929437585476, 47.9516919040582],
        [106.929376302974, 47.9516333770787],
        [106.929324515514, 47.9515850286262],
        [106.92929966185, 47.9515592261774],
        [106.929271148845, 47.9515226426559],
        [106.929227894152, 47.9514572007893],
        [106.929158858595, 47.9513491715271],
        [106.929102448619, 47.9512627700609],
        [106.929068144879, 47.9512208679487],
        [106.929025292184, 47.9511747309291],
        [106.928990179953, 47.9511393462039],
        [106.928964010581, 47.9511162039497],
        [106.928924509658, 47.9510870892978],
        [106.928879177532, 47.9510600565764],
        [106.928809773253, 47.9510215188281],
        [106.928743860141, 47.9509873005235],
        [106.928683298895, 47.9509581301137],
        [106.928599680831, 47.9509216653026],
        [106.928512228956, 47.9508875495209],
        [106.92839141763, 47.950846108761],
        [106.928278992482, 47.9508140434334],
        [106.928196164921, 47.950793919304],
        [106.928135980491, 47.9507826957649],
        [106.928082436655, 47.9507759310644],
        [106.92803512692, 47.9507724785671],
        [106.927989528594, 47.950772009121],
        [106.927934714915, 47.9507741647959],
        [106.927880517272, 47.9507785561855],
        [106.927819905664, 47.9507860187598],
        [106.927740609741, 47.9507992621762],
        [106.927694619311, 47.9508091897923],
        [106.927673127313, 47.9508123068425],
        [106.927625876033, 47.9508131000446],
        [106.927572494975, 47.9508080395594],
        [106.927515939309, 47.950797077723],
        [106.927483068189, 47.9507866788622],
        [106.927414051517, 47.9507590840645],
        [106.927267422454, 47.9507099289202],
        [106.927193348894, 47.9506856328358],
        [106.927150842437, 47.9506741664796],
        [106.927067560719, 47.9506596828981],
        [106.926981325628, 47.9506452478799],
        [106.926938787695, 47.9506356718988],
        [106.926906755642, 47.9506266481014],
        [106.926872235166, 47.9506144460998],
        [106.926843778817, 47.9506018960607],
        [106.92680147291, 47.9505767986803],
        [106.926777445723, 47.9505565135723],
        [106.926749350902, 47.9505260571319],
        [106.92672790297, 47.9504988445461],
        [106.926705717595, 47.9504652476731],
        [106.926686467606, 47.9504300742885],
        [106.926664152729, 47.9503805800998],
        [106.926640546424, 47.9503213642396],
        [106.926624582558, 47.9502700705074],
        [106.926609965877, 47.9501948772918],
        [106.926604725528, 47.9501334230191],
        [106.926608567432, 47.9500777720716],
        [106.926624072643, 47.9500179536657],
        [106.926645707633, 47.9499639898463],
        [106.92668749733, 47.9498957906583],
        [106.926743537684, 47.9498134559263],
        [106.926774930319, 47.949775716776],
        [106.926820243559, 47.9497109547968],
        [106.926777413347, 47.9496181555535],
        [106.92659181486, 47.9495277359163],
        [106.926399079354, 47.9494968028352],
        [106.926306310688, 47.9495419101311],
        [106.926187306999, 47.949515838785],
        [106.926113024796, 47.9494454740295],
        [106.925961691379, 47.9493699696484],
        [106.925751063861, 47.9493806562923],
        [106.925681431153, 47.9493826114185],
        [106.925622627183, 47.9493834891567],
        [106.925589808223, 47.949382163556],
        [106.925527423152, 47.9493732836502],
        [106.925496153725, 47.9493657581233],
        [106.925452781221, 47.9493526981685],
        [106.925400150197, 47.9493345660375],
        [106.925335911623, 47.949308996513],
        [106.925263589943, 47.9492780238618],
        [106.925215645286, 47.949253441793],
        [106.925177438488, 47.949229903837],
        [106.925148980341, 47.9492089001707],
        [106.925121029412, 47.9491817721212],
        [106.925087336312, 47.9491404509711],
        [106.925062726364, 47.9491074791269],
        [106.92504673372, 47.9490815741554],
        [106.925027318256, 47.9490362384317],
        [106.925016543479, 47.9489848035059],
        [106.925005886512, 47.9489090778917],
        [106.924998097484, 47.9488064418638],
        [106.924994265473, 47.9487032734374],
        [106.924998033632, 47.9486456394847],
        [106.925010662812, 47.9485878562446],
        [106.925023015, 47.9485480378617],
        [106.92504536765, 47.9484880117124],
        [106.925075434684, 47.9484104227029],
        [106.925099640836, 47.9483580614754],
        [106.925121988989, 47.9483166315074],
        [106.925141283943, 47.9482858962771],
        [106.925165779677, 47.9482525871872],
        [106.925189275365, 47.9482255337814],
        [106.92524073727, 47.9481790100533],
        [106.925274523001, 47.9481525070326],
        [106.925304010871, 47.9481322884744],
        [106.925367726939, 47.9480974721207],
        [106.925431663341, 47.9480686056817],
        [106.925506170374, 47.9480458501359],
        [106.925559123355, 47.9480313449707],
        [106.925595946995, 47.9480231674353],
        [106.925638796993, 47.9480171131993],
        [106.925713677244, 47.9480106048056],
        [106.925834359968, 47.9480024389614],
        [106.926044034205, 47.9479944754647],
        [106.926269409706, 47.9479936507864],
        [106.926325394302, 47.947990203685],
        [106.926374587217, 47.9479836368354],
        [106.926436036994, 47.9479720346817],
        [106.926476175535, 47.9479607562839],
        [106.926505102229, 47.9479495228522],
        [106.926526576241, 47.947938734585],
        [106.926554568539, 47.9479186311399],
        [106.92657618914, 47.9478955500397],
        [106.926586465693, 47.9478758584841],
        [106.92659765146, 47.9478369556111],
        [106.926614685519, 47.9477798450638],
        [106.926628761708, 47.947719968202],
        [106.926641561759, 47.9476469747282],
        [106.92664737048, 47.9475846589049],
        [106.926648959582, 47.9475152501287],
        [106.926643043841, 47.9474682650484],
        [106.926635983264, 47.9474450661369],
        [106.926625178809, 47.9474195910413],
        [106.926583197557, 47.9473422142718],
        [106.926553722277, 47.947290678622],
        [106.926520202745, 47.9472373910928],
        [106.926469131146, 47.9471633804857],
        [106.926420590238, 47.9471014198947],
        [106.926344736021, 47.9470178162193],
        [106.926307100292, 47.9469813136367],
        [106.926269103936, 47.9469477896089],
        [106.926208418584, 47.9469006741269],
        [106.92612332653, 47.9468417100769],
        [106.926021175237, 47.9467757627913],
        [106.925929807714, 47.9467231947197],
        [106.925878784678, 47.9466974408343],
        [106.925819662348, 47.9466705807827],
        [106.925601436457, 47.946580472311],
        [106.925445322244, 47.9465142687186],
        [106.925301218477, 47.9464531579869],
        [106.925244802206, 47.9464254831496],
        [106.925186002732, 47.9463939978847],
        [106.925051793306, 47.9463144024878],
        [106.92499026349, 47.9462745939974],
        [106.924925045554, 47.9462292079116],
        [106.924756309356, 47.9461023054771],
        [106.924706053442, 47.946065818183],
        [106.924683275413, 47.9460452965532],
        [106.924668518437, 47.9460268019953],
        [106.924650008591, 47.9459982089502],
        [106.924631975385, 47.9459665420223],
        [106.924611821578, 47.9459247325405],
        [106.924580933463, 47.9458468458553],
        [106.92455867884, 47.9457668052939],
        [106.924550906, 47.9457192896136],
        [106.924541464917, 47.9456215099248],
        [106.924520431573, 47.9454712008353],
        [106.924513525679, 47.9453996318875],
        [106.924508967915, 47.9453496277832],
        [106.924510677526, 47.945322917019],
        [106.924516868459, 47.945300691174],
        [106.924528496693, 47.9452723256573],
        [106.924544410196, 47.9452405669986],
        [106.924561771609, 47.9452135342772],
        [106.924593346806, 47.945176289754],
        [106.924630088608, 47.9451435679214],
        [106.92465909714, 47.9451235490126],
        [106.924699387667, 47.9451000542242],
        [106.924784533679, 47.9450589219318],
        [106.924889268725, 47.9450148137827],
        [106.924951556669, 47.9449831189758],
        [106.925053377012, 47.9449251540727],
        [106.925143216586, 47.9448727568723],
        [106.925333150704, 47.9447577218914],
        [106.925461640442, 47.9446814521873],
        [106.925548918748, 47.9446270485994],
        [106.92559511872, 47.9445980391682],
        [106.925749200465, 47.944503693091],
        [106.925939636405, 47.9443981477564],
        [106.926022901036, 47.944345775737],
        [106.926088335708, 47.9443003617723],
        [106.926167849267, 47.9442374461013],
        [106.926241105343, 47.9441707442844],
        [106.926401064158, 47.9440331210317],
        [106.926566614957, 47.9438986786811],
        [106.926853638984, 47.9436826174589],
        [106.926950637162, 47.9436077956633],
        [106.927002407535, 47.9435642082217],
        [106.927051285688, 47.9435200766902],
        [106.927077095332, 47.9434914557661],
        [106.927102154941, 47.9434511562459],
        [106.92712217295, 47.9434029516849],
        [106.92713133974, 47.9433601718345],
        [106.927136920033, 47.9432792067701],
        [106.927144742336, 47.943173956413],
        [106.927151307387, 47.9430157242963],
        [106.927152040334, 47.9429501358401],
        [106.92714853118, 47.9427605875311],
        [106.927151100543, 47.9427013500873],
        [106.927156997398, 47.9426483881127],
        [106.927167459211, 47.9425686865957],
        [106.927173395636, 47.9425450946804],
        [106.927181410394, 47.9425244822191],
        [106.927208083386, 47.9424783128239],
        [106.927241110989, 47.9424389809743],
        [106.927282167738, 47.9424028686975],
        [106.927301585, 47.9423896891329],
        [106.927321112879, 47.9423791400853],
        [106.927354326641, 47.9423659677153],
        [106.927392775356, 47.9423551875419],
        [106.927426966681, 47.9423493608344],
        [106.927484256194, 47.9423439019496],
        [106.927540351406, 47.9423409656631],
        [106.927684396718, 47.9423424549404],
        [106.927750118273, 47.9423394377149],
        [106.927843181917, 47.9423283391816],
        [106.927923291727, 47.9423137809563],
        [106.928010180625, 47.9422920371479],
        [106.928045290158, 47.9422808405883],
        [106.928076404003, 47.9422689614435],
        [106.928110716736, 47.9422532089185],
        [106.92814456452, 47.9422349517816],
        [106.928177511183, 47.9422144229573],
        [106.928208972166, 47.9421919857716],
        [106.928235790849, 47.9421699946496],
        [106.92826124616, 47.9421459404828],
        [106.928285054812, 47.9421200957659],
        [106.928306857975, 47.9420928463078],
        [106.928322287644, 47.9420699001059],
        [106.928336800003, 47.9420437055526],
        [106.928369940021, 47.9419682893052],
        [106.928392785499, 47.9419009120975],
        [106.928429637018, 47.9417527919578],
        [106.928477836183, 47.9415910057204],
        [106.928516041182, 47.9414750992964],
        [106.928560449705, 47.9413586101118],
        [106.928657790525, 47.9411249770361],
        [106.928761627147, 47.9408773990727],
        [106.928808359518, 47.9407519571371],
        [106.928837226857, 47.9406601462488],
        [106.928864214612, 47.940563112098],
        [106.92888966003, 47.9404596747742],
        [106.92891421422, 47.9403471902706],
        [106.928946356889, 47.9401711542754],
        [106.92896617435, 47.9400538242247],
        [106.928973678293, 47.9399879740658],
        [106.928984955791, 47.9398371442688],
        [106.928994206218, 47.9397673604753],
        [106.929020254181, 47.9396336609647],
        [106.929033535369, 47.9395838762949],
        [106.929048583725, 47.9395389542594],
        [106.929077607546, 47.9394701588208],
        [106.929115767579, 47.9393948289083],
        [106.929146376004, 47.9393397256479],
        [106.929170385205, 47.9393029127992],
        [106.929207890532, 47.9392567254176],
        [106.929258597906, 47.9392039325155],
        [106.929298163579, 47.9391693895557],
        [106.929406055245, 47.9390896574617],
        [106.929451212004, 47.9390512006525],
        [106.929519517312, 47.9389814789122],
        [106.929543379024, 47.9389528597867],
        [106.929562622717, 47.9389258315619],
        [106.929588182349, 47.9388801576932],
        [106.929612043161, 47.9388242531368],
        [106.92962853403, 47.9387668745916],
        [106.929649138397, 47.9386513845538],
        [106.929677670288, 47.938522638509],
        [106.929690218529, 47.9384556992712],
        [106.929700453713, 47.938377865646],
        [106.929711843627, 47.9382570911919],
        [106.929724555544, 47.9381212890663],
        [106.929727910914, 47.9380390766421],
        [106.92972346017, 47.9379511067582],
        [106.92970337561, 47.9377697467764],
        [106.929686092439, 47.9375652922045],
        [106.929673484844, 47.9374712869704],
        [106.929660954589, 47.9374097175844],
        [106.929622768476, 47.9372933641974],
        [106.929602765755, 47.9372342616519],
        [106.929595217745, 47.9372028285477],
        [106.929591337171, 47.9371630236546],
        [106.929592196023, 47.9371216314582],
        [106.929599010186, 47.9370797086617],
        [106.929617204371, 47.9370139637235],
        [106.929643485259, 47.9369309634932],
        [106.929674115268, 47.9368537629908],
        [106.929708168997, 47.9367818855756],
        [106.92974177936, 47.9367226274474],
        [106.929781538387, 47.936664466492],
        [106.929829260012, 47.9366041606535],
        [106.929877831497, 47.9365501518681],
        [106.929936314409, 47.9364918650076],
        [106.929987046965, 47.9364470670785],
        [106.930123962451, 47.9363359630343],
        [106.930235411835, 47.9362423759849],
        [106.930264699157, 47.9362137955303],
        [106.930287686727, 47.936186964257],
        [106.930316534281, 47.9361442446612],
        [106.930346890896, 47.9360884723052],
        [106.930374815745, 47.9360252454688],
        [106.930399809703, 47.9359510855742],
        [106.930416039768, 47.9358874279625],
        [106.930428684236, 47.9358173527886],
        [106.930437079408, 47.9357532032478],
        [106.930439071406, 47.9357066822176],
        [106.930436261924, 47.9356711670907],
        [106.930425414302, 47.9355996646928],
        [106.930404746982, 47.935434266778],
        [106.930380576802, 47.9353046762698],
        [106.930341665835, 47.9351688336748],
        [106.930290669779, 47.9349681967249],
        [106.930273251709, 47.9348936240416],
        [106.930266983435, 47.934851597823],
        [106.930266871919, 47.9347922506619],
        [106.930276161915, 47.9347084464377],
        [106.930287737989, 47.9346385421351],
        [106.930304672223, 47.9345649712964],
        [106.930332408214, 47.9344720002826],
        [106.930365685828, 47.9343851995174],
        [106.930402037324, 47.9343036687794],
        [106.930433224014, 47.9342508174213],
        [106.930456925647, 47.934220084889],
        [106.930493393156, 47.9341783077828],
        [106.93056322821, 47.9341056362662],
        [106.930652275482, 47.9340293899444],
        [106.930707900349, 47.933974764224],
        [106.930750019198, 47.9339269985322],
        [106.930787158501, 47.9338748990074],
        [106.930832297273, 47.9337988676237],
        [106.930870136248, 47.9337263651797],
        [106.930922064901, 47.9336121126089],
        [106.930984761138, 47.9334649295629],
        [106.93104601756, 47.933304535476],
        [106.931090385613, 47.9331740690281],
        [106.931150033148, 47.9329810448394],
        [106.931195106269, 47.9328395634951],
        [106.931214422807, 47.9327622173025],
        [106.931226507897, 47.9326885430419],
        [106.931233264504, 47.9326189040393],
        [106.931233984861, 47.9325083944469],
        [106.931231914621, 47.9324138846931],
        [106.931227571795, 47.9323362570127],
        [106.931200256687, 47.932122221963],
        [106.931183211836, 47.9319242640935],
        [106.93117373478, 47.9317514395773],
        [106.93117159889, 47.9316124682409],
        [106.931173406528, 47.9315311884137],
        [106.931182705518, 47.9314766850011],
        [106.931202518481, 47.9314039514313],
        [106.931223202889, 47.9313408496006],
        [106.931246371223, 47.931282967435],
        [106.931280651581, 47.9312111682609],
        [106.931314145931, 47.9311550802428],
        [106.931349997405, 47.9311072506991],
        [106.931397385381, 47.9310529325468],
        [106.931442507965, 47.9310058098703],
        [106.931481350584, 47.9309702722603],
        [106.931522197791, 47.9309391026575],
        [106.931599145584, 47.9308870427029],
        [106.931665302412, 47.9308448725928],
        [106.931693502453, 47.9308237070485],
        [106.931726683839, 47.930791505024],
        [106.931753907217, 47.9307576914144],
        [106.93177161217, 47.9307266477167],
        [106.931794255301, 47.9306725148248],
        [106.931826360198, 47.9305845908063],
        [106.9318591234, 47.9304666788942],
        [106.931888493459, 47.9303389445867],
        [106.931903693801, 47.9302351853056],
        [106.93190747455, 47.9301591440293],
        [106.931906339606, 47.9300466451366],
        [106.931906132762, 47.9299693142325],
        [106.931901862781, 47.9299264732282],
        [106.931892002614, 47.9298815907629],
        [106.931879506534, 47.9298456007939],
        [106.931858664746, 47.9298067824571],
        [106.931822958962, 47.9297555552747],
        [106.931803732356, 47.9297321171435],
        [106.931755952275, 47.9296805212391],
        [106.931737053023, 47.9296562530337],
        [106.931708076866, 47.9296077382066],
        [106.931684975981, 47.9295563815218],
        [106.931672168736, 47.9295172178454],
        [106.931662620634, 47.9294755099868],
        [106.931657479209, 47.9294399049277],
        [106.931655126583, 47.9294041379906],
        [106.93165359234, 47.9293648825833],
        [106.931657659973, 47.9293423464721],
        [106.931666514698, 47.9293260885282],
        [106.931694384688, 47.9292897298372],
        [106.931730625568, 47.929224121596],
        [106.931745574998, 47.9291891379684],
        [106.931757080925, 47.9291554286801],
        [106.93176734039, 47.9291131992148],
        [106.931773266023, 47.9290706576848],
        [106.931773890153, 47.9290360805507],
        [106.931769393543, 47.9289667257339],
        [106.931765738698, 47.928908203251],
        [106.931766126306, 47.9288790337405],
        [106.931772917986, 47.9288360830189],
        [106.931791008748, 47.9287681167552],
        [106.931834373158, 47.9286341411528],
        [106.931863866424, 47.9285434157461],
        [106.931877494751, 47.9284936688478],
        [106.931892186975, 47.9284262556672],
        [106.931897422828, 47.928379586249],
        [106.931895124161, 47.9283178765688],
        [106.931892880352, 47.9282927342223],
        [106.931888839698, 47.9282789826889],
        [106.931880110878, 47.9282653786444],
        [106.931863468025, 47.9282469110661],
        [106.931808615675, 47.9282023352696],
        [106.931767665945, 47.9281658470762],
        [106.931748326924, 47.9281416004545],
        [106.931740881437, 47.9281246842069],
        [106.931732015021, 47.9280931269963],
        [106.931715096974, 47.9280284126812],
        [106.931707128981, 47.9279660698783],
        [106.931703609934, 47.9278498612821],
        [106.931697279606, 47.9277490904482],
        [106.931697803011, 47.9276939620068],
        [106.931701805894, 47.9276399370335],
        [106.931709032846, 47.9276060262972],
        [106.931740441668, 47.9275404989949],
        [106.93175467344, 47.927501663571],
        [106.93176206137, 47.927471887018],
        [106.93176443558, 47.9274471322794],
        [106.93176447515, 47.9274068480477],
        [106.931764508425, 47.9273645745155],
        [106.931761934566, 47.927338641665],
        [106.931754136544, 47.9273079954677],
        [106.931740064852, 47.927270760837],
        [106.931698500885, 47.9271934632078],
        [106.931677197745, 47.9271485411723],
        [106.931666723341, 47.9271192502533],
        [106.931661021639, 47.9270855760386],
        [106.931658383927, 47.9270251424964],
        [106.931654616667, 47.9269769999886],
        [106.931655600526, 47.9269504421093],
        [106.931662210543, 47.926914772299],
        [106.931672631886, 47.9268884059752],
        [106.931682548711, 47.9268739349841],
        [106.931709596721, 47.9268422851434],
        [106.931740539694, 47.9268017661886],
        [106.931755501715, 47.9267765141249],
        [106.931763992215, 47.9267535004737],
        [106.931772653585, 47.9267177272414],
        [106.931784367255, 47.9266427822387],
        [106.931786222556, 47.92660400617],
        [106.93178544824, 47.9265420159013],
        [106.931780394949, 47.926474930074],
        [106.931781819475, 47.9264445797536],
        [106.931788338661, 47.9264166656966],
        [106.931803319568, 47.9263727194255],
        [106.931838711487, 47.9262843754236],
        [106.93185502429, 47.9262241846984],
        [106.931875911944, 47.9261147542925],
        [106.93191177241, 47.9259569340653],
        [106.931918187275, 47.9259112709884],
        [106.931919992214, 47.9258702681984],
        [106.931917787976, 47.9258149491007],
        [106.931911531392, 47.9257729129896],
        [106.931901355563, 47.9257330334528],
        [106.931889660779, 47.9257050330609],
        [106.931873084475, 47.9256794068792],
        [106.931848945772, 47.925650470293],
        [106.931788901637, 47.9255962312811],
        [106.931761440838, 47.9255635643071],
        [106.931732964705, 47.9255224248201],
        [106.93170703725, 47.9254777824738],
        [106.931686085744, 47.9254322156243],
        [106.931671328769, 47.9253880535159],
        [106.931658174385, 47.9253319367195],
        [106.931650594899, 47.925285367126],
        [106.931644517281, 47.925224920094],
        [106.931640372305, 47.9251613254349],
        [106.931640284172, 47.9251112439888],
        [106.931645633339, 47.9250531136104],
        [106.931659243679, 47.9249711781774],
        [106.931679775202, 47.9248733346367],
        [106.931700924558, 47.9248104000799],
        [106.931732680519, 47.924735948805],
        [106.931752024037, 47.9246979866228],
        [106.931802565036, 47.9246113180579],
        [106.931823276423, 47.924571926853],
        [106.931869439523, 47.9244677727696],
        [106.931898405787, 47.9243821690019],
        [106.931912816523, 47.9243163062526],
        [106.931926303656, 47.9242224521045],
        [106.931935943489, 47.9241376559281],
        [106.931939945472, 47.9240694756259],
        [106.931938015527, 47.9239715520455],
        [106.931927733578, 47.9238714368174],
        [106.931918593768, 47.9237915194631],
        [106.931912522445, 47.9237683709136],
        [106.931903806216, 47.9237483421123],
        [106.931884706414, 47.9237200908096],
        [106.93184799339, 47.9236777831032],
        [106.931802689143, 47.9236297970775],
        [106.931782867186, 47.9235966831405],
        [106.931760766346, 47.9235427534953],
        [106.931743292519, 47.9234923770716],
        [106.931727661403, 47.9234328140732],
        [106.931716864142, 47.9233755515405],
        [106.93171012822, 47.9233144758824],
        [106.931707352013, 47.9232487849035],
        [106.931708439293, 47.9231763939754],
        [106.931714958479, 47.9230917857574],
        [106.931725553392, 47.9230282792317],
        [106.931739596305, 47.9229743747676],
        [106.931751777622, 47.9229433274726],
        [106.93178833956, 47.922870368173],
        [106.931802163939, 47.9228368252593],
        [106.931818552284, 47.9227830071301],
        [106.931827527518, 47.9227388998803],
        [106.931830096882, 47.9226992496707],
        [106.931828125568, 47.9226251428361],
        [106.931825205469, 47.922496636011],
        [106.931818326555, 47.9223620650573],
        [106.93180704366, 47.9222095481322],
        [106.93179391176, 47.9220959808449],
        [106.931773250735, 47.9219629405374],
        [106.93175174165, 47.9218724471557],
        [106.931728909662, 47.9218033387531],
        [106.931703294272, 47.9217400147899],
        [106.931682794226, 47.9216949866344],
        [106.931666688267, 47.9216658827743],
        [106.931646865411, 47.9216382475072],
        [106.931605803265, 47.9215889089011],
        [106.931550112748, 47.9215215964446],
        [106.931527639589, 47.9214890598723],
        [106.93150576358, 47.9214517496985],
        [106.931430754726, 47.921302610627],
        [106.931285787609, 47.9210450555849],
        [106.931167942247, 47.9208436829896],
        [106.93111496948, 47.9207424364143],
        [106.9310707696, 47.9206428391958],
        [106.931056144825, 47.9206060479308],
        [106.9310504746, 47.9205846818376],
        [106.931048931363, 47.9205432707554],
        [106.931061342907, 47.9204870019736],
        [106.931070632004, 47.9204397174191],
        [106.931073025999, 47.9204112439838],
        [106.931071601473, 47.9203849541024],
        [106.931067498766, 47.9203601508004],
        [106.931060413008, 47.9203365642811],
        [106.931047293698, 47.9203044297057],
        [106.931027887227, 47.920266583536],
        [106.930981425552, 47.9201909775317],
        [106.930876690507, 47.9200074942505],
        [106.930826681007, 47.9199303369156],
        [106.930795756919, 47.9198892046231],
        [106.930739160784, 47.9198196861296],
        [106.930669879711, 47.9197338674241],
        [106.930625278734, 47.9196826672214],
        [106.930580642683, 47.9196368665482],
        [106.930493550537, 47.9195532610742],
        [106.930394954264, 47.9194557152091],
        [106.930339355477, 47.919404731743],
        [106.93028601129, 47.9193621029787],
        [106.930158555773, 47.9192704350826],
        [106.930104350935, 47.9192283126366],
        [106.93005321998, 47.9191839086105],
        [106.929998836177, 47.9191329278424],
        [106.929814717975, 47.9189480011494],
        [106.929718809775, 47.9188558799949],
        [106.929671667314, 47.9188065971468],
        [106.929630707691, 47.9187581659567],
        [106.929584244218, 47.9186983808257],
        [106.929555023446, 47.9186613494418],
        [106.929542209006, 47.9186405894916],
        [106.929532571871, 47.9186137330374],
        [106.929525267577, 47.918575063988],
        [106.929522654147, 47.918546202945],
        [106.929522277331, 47.918494678087],
        [106.92952426933, 47.9183532731851],
        [106.929527620204, 47.9182484068386],
        [106.929535131341, 47.9181896289482],
        [106.929545739744, 47.9181506037674],
        [106.929557395857, 47.9181241987728],
        [106.929572735593, 47.9180965266335],
        [106.929586206538, 47.9180774079461],
        [106.929635061309, 47.9180174807222],
        [106.929659045329, 47.9179746298254],
        [106.929692315748, 47.917899521146],
        [106.929717986896, 47.9178447029707],
        [106.929729003591, 47.9178135945218],
        [106.929736582178, 47.9177828260167],
        [106.929737972529, 47.9177622567228],
        [106.929735333919, 47.9177452892138],
        [106.929729366917, 47.9177258395759],
        [106.929705993537, 47.9176823591536],
        [106.929686334357, 47.9176412520422],
        [106.92967210978, 47.9176116985211],
        [106.929666494413, 47.9175952751019],
        [106.929663777561, 47.9175737291443],
        [106.929664682279, 47.9175465570281],
        [106.929669088957, 47.9175218445575],
        [106.929682090456, 47.9174784216918],
        [106.92970805838, 47.9173967371697],
        [106.929748158251, 47.917305064777],
        [106.929797681218, 47.9172067347031],
        [106.929883801197, 47.9170525405424],
        [106.929918828891, 47.9169828565736],
        [106.929937549179, 47.9169378886727],
        [106.92995037441, 47.9168932544202],
        [106.929966779843, 47.9168139009408],
        [106.929983287799, 47.9167374810499],
        [106.929991175752, 47.916689994148],
        [106.929996054574, 47.9166089211648],
        [106.929992501353, 47.916465726612],
        [106.929983197866, 47.9162156386409],
        [106.929982047633, 47.9160031926933],
        [106.929987177366, 47.9158028318353],
        [106.929993974442, 47.915668574745],
        [106.930002272487, 47.915558834073],
        [106.930014200195, 47.915466649966],
        [106.930016644553, 47.9154253450037],
        [106.930013431275, 47.9153728326901],
        [106.930002027871, 47.9152923424677],
        [106.929993370997, 47.9152255228396],
        [106.929983667312, 47.9151886551324],
        [106.929970729666, 47.9151607581625],
        [106.929942116835, 47.9151113548052],
        [106.929914891659, 47.915066542487],
        [106.929844649211, 47.9149604908341],
        [106.929813602816, 47.914905519774],
        [106.929787859722, 47.914850992979],
        [106.929771327485, 47.9148087329367],
        [106.929758393435, 47.9147646121971],
        [106.929748620502, 47.9147181172474],
        [106.929741735293, 47.9146629843094],
        [106.929743907156, 47.9145914486365],
        [106.929754656752, 47.9144905204212],
        [106.929775068665, 47.9143894294287],
        [106.929798574245, 47.9142534375462],
        [106.929811300551, 47.9141938259843],
        [106.929830296031, 47.9141224557868],
        [106.929849908447, 47.9140588098662],
        [106.929870993951, 47.9140001255054],
        [106.929893911375, 47.9139454422284],
        [106.929916890852, 47.9138952204881],
        [106.929934372773, 47.91386351399],
        [106.929958115774, 47.9138280330374],
        [106.929980388384, 47.9138009904234],
        [106.929998485442, 47.9137839788476],
        [106.930050682993, 47.9137413105131],
        [106.930099349805, 47.913692985443],
        [106.930143680986, 47.9136422501897],
        [106.930175448638, 47.9136020091255],
        [106.930194286737, 47.9135731507803],
        [106.930211451198, 47.9135339880032],
        [106.930229189426, 47.9134718160715],
        [106.930240752909, 47.9134212130186],
        [106.930253463926, 47.9133446609274],
        [106.930268558147, 47.9132306592676],
        [106.93027428593, 47.9131560865842],
        [106.930282565988, 47.9129574299415],
        [106.930299244814, 47.912772803622],
        [106.930321932012, 47.9125862761358],
        [106.930348229987, 47.9124136692555],
        [106.930381225213, 47.912231036733],
        [106.930455618032, 47.9118917935714],
        [106.930485113997, 47.9117563053093],
        [106.930496193645, 47.9116831166825],
        [106.930500287358, 47.9116245114621],
        [106.930501384531, 47.9115627810975],
        [106.930490873255, 47.9114102120117],
        [106.930488383033, 47.9113229660821],
        [106.930490266213, 47.9112639759518],
        [106.930505481843, 47.9111532217439],
        [106.930521181308, 47.9110554600415],
        [106.930536437407, 47.9110040422028],
        [106.930573593796, 47.9109050808049],
        [106.930639289272, 47.9107219806349],
        [106.930744717695, 47.9104374639179],
        [106.930828284498, 47.9102150642739],
        [106.930887280923, 47.9100670862271],
        [106.930930329671, 47.909969601516],
        [106.930978117846, 47.9098741025079],
        [106.93103865481, 47.9097630335372],
        [106.931081098314, 47.9096934386014],
        [106.931097707893, 47.9096612941334],
        [106.931115040527, 47.9096153801457],
        [106.931128018643, 47.9095665361668],
        [106.931134389441, 47.9095254092703],
        [106.931138763743, 47.9094656070522],
        [106.931138156701, 47.9093193700929],
        [106.931145527544, 47.9092439655366],
        [106.931145774858, 47.90922771119],
        [106.931148659883, 47.9092119469738],
        [106.931154099882, 47.9091985425787],
        [106.931163503193, 47.909184181305],
        [106.931203968189, 47.9091395164755],
        [106.931230197815, 47.9091119981203],
        [106.931262557221, 47.9090826316582],
        [106.931381976397, 47.9089870256308],
        [106.931527497496, 47.9088708296251],
        [106.931610610142, 47.9087905597366],
        [106.931644276262, 47.9087616177545],
        [106.93170584295, 47.9087191166939],
        [106.93181431288, 47.908654757611],
        [106.931937371612, 47.9085844387209],
        [106.931993599925, 47.908555564188],
        [106.93213537175, 47.9084885458098],
        [106.932198464588, 47.9084565470321],
        [106.932317932327, 47.9083898317254],
        [106.932416078939, 47.908329386492],
        [106.932509825168, 47.9082690581706],
        [106.932536317397, 47.9082488719879],
        [106.932557370526, 47.9082295095843],
        [106.932593588024, 47.9081861361813],
        [106.932621697234, 47.9081390090081],
        [106.930639418774, 47.9081862378047],
        [106.927405181504, 47.908210327045],
        [106.925690593446, 47.9082425992166],
        [106.923476267416, 47.9082587474433],
        [106.923101759139, 47.9082545359182],
        [106.922466666903, 47.9082337121162],
        [106.920062175629, 47.9081690805387],
        [106.918380983895, 47.9081202815258],
        [106.916621723814, 47.9080692647848],
        [106.916361658764, 47.9080666162814],
        [106.916090572522, 47.9080705580099],
        [106.91305555487, 47.908166665859],
        [106.909000350786, 47.9082843592358],
        [106.903986836324, 47.9084469018031],
        [106.900634123266, 47.9085958825939],
        [106.898523341579, 47.908698631037],
        [106.898120562214, 47.9087178504485],
        [106.897722709336, 47.9087696406065],
        [106.89690915923, 47.908896121259],
        [106.896499735674, 47.9089380512501],
        [106.894499999575, 47.9091111104894],
        [106.894668206972, 47.9122346627995],
        [106.894702165373, 47.9134676117409],
        [106.89472989327, 47.9141757181349],
        [106.89473348876, 47.9147668110395],
        [106.894750000312, 47.9151666667083],
        [106.901559907864, 47.9157943062623],
        [106.904820378358, 47.9160698009806],
        [106.907027988251, 47.9162588177903],
        [106.908342739526, 47.9163659234487],
        [106.910085493451, 47.9165196247809],
        [106.910566481458, 47.9165581868109],
        [106.910796522641, 47.9165830161933],
        [106.910855496584, 47.9165927801328],
        [106.910893432686, 47.9166100588072],
        [106.910988553979, 47.9166247060654],
        [106.911388434828, 47.9166583470052],
        [106.911613985697, 47.9166787706088],
        [106.912250372956, 47.9167047763044],
        [106.913170764319, 47.9167377976113],
        [106.914166944249, 47.9167668636999],
        [106.914401551291, 47.9167746428355],
        [106.916388887537, 47.9168333325923],
        [106.916371728473, 47.9176104655506],
        [106.916362727158, 47.9177463378233],
        [106.916332103444, 47.9180559941888],
        [106.916258867153, 47.9184266821457],
        [106.916177849029, 47.9188144644161],
        [106.916035287598, 47.9195859361421],
        [106.915900871328, 47.9202743284975],
        [106.915742688674, 47.9210027038118],
        [106.91560782634, 47.9217551962454],
        [106.915434350715, 47.922525295606],
        [106.915285537198, 47.9232799050436],
        [106.915189130774, 47.9237829300383],
        [106.915096030258, 47.9242236940683],
        [106.915014189253, 47.924741556078],
        [106.914861727187, 47.9254736051228],
        [106.914719409473, 47.926252608671],
        [106.914361110577, 47.9288888885114],
        [106.913364723803, 47.9287596577321],
        [106.913167469203, 47.928734670069],
        [106.912882556785, 47.9286904072366],
        [106.912409702246, 47.9286455040868],
        [106.911571344342, 47.9285765251865],
        [106.911379965913, 47.9285645695992],
        [106.906826944808, 47.9281918851474],
        [106.906625649554, 47.9281828226792],
        [106.906535750624, 47.9281964671932],
        [106.906417476286, 47.9282251645598],
        [106.906235224176, 47.9282840881402],
        [106.906031824509, 47.9283579440639],
        [106.905843593707, 47.9284509897215],
        [106.905577283765, 47.928584217088],
        [106.905427999902, 47.9286547437215],
        [106.905292903745, 47.9287177430295],
        [106.905218707877, 47.9287651498918],
        [106.905162938219, 47.928821972656],
        [106.905108506752, 47.9289152269562],
        [106.905051353937, 47.9290328295015],
        [106.904978094264, 47.9292041665391],
        [106.904976211983, 47.9292115382819],
        [106.904933835029, 47.9293774533069],
        [106.904910365421, 47.929722944958],
        [106.904884753629, 47.9300101461514],
        [106.904866549552, 47.930302084074],
        [106.90487185735, 47.9305450260322],
        [106.904892292645, 47.9307075164388],
        [106.904936908911, 47.9309376556483],
        [106.905006289808, 47.93115280226],
        [106.905080443408, 47.9313994611163],
        [106.905229336964, 47.9318101419246],
        [106.90538376315, 47.9321745553115],
        [106.905587005436, 47.9324895509521],
        [106.905774811758, 47.9327780687529],
        [106.905942851881, 47.9330207409145],
        [106.90614467144, 47.9332968741515],
        [106.906451888844, 47.9336854819995],
        [106.906789276704, 47.9341076111774],
        [106.907270444575, 47.9347023328464],
        [106.907681879016, 47.9352690478283],
        [106.908285522859, 47.9360464325969],
        [106.908833180307, 47.9367761398071],
        [106.909262989695, 47.9373498344274],
        [106.909436429348, 47.9377382282367],
        [106.909479772174, 47.9378207842019],
        [106.909580633839, 47.9380201746914],
        [106.909693238852, 47.9382297383118],
        [106.909835745423, 47.9384655378544],
        [106.9099347347, 47.9385999865002],
        [106.910088838929, 47.9387578238146],
        [106.910267618756, 47.9388982367643],
        [106.910430777359, 47.9390073146359],
        [106.910582019944, 47.9390874289417],
        [106.910861830509, 47.9392212984242],
        [106.911158374759, 47.9393184350977],
        [106.911424927518, 47.9393869067804],
        [106.911702503268, 47.9394600549376],
        [106.912128817891, 47.9395453070703],
        [106.912375866153, 47.9395752158236],
        [106.912596805298, 47.939583686538],
        [106.912759732775, 47.9395882640871],
        [106.913147931432, 47.9396206801503],
        [106.913518683241, 47.9396703982703],
        [106.914017294363, 47.9397544381169],
        [106.914495317305, 47.9398533194751],
        [106.914780814283, 47.9399013019036],
        [106.914790451418, 47.9400416959675],
        [106.914785055486, 47.9402571051813],
        [106.914778999451, 47.9404545819134],
        [106.91481297314, 47.9406513904494],
        [106.914848856989, 47.9407793855602],
        [106.914857609191, 47.9408958711476],
        [106.91480330363, 47.9414739508622],
        [106.914684197418, 47.9423461835296],
        [106.91456857428, 47.9430718240055],
        [106.914396129278, 47.9441871802942],
        [106.914285862503, 47.9448170321804],
        [106.914169060354, 47.9457520267347],
        [106.914023212801, 47.9467443269892],
        [106.913913091716, 47.9476193988162],
        [106.913794612332, 47.9481477091495],
        [106.913727748637, 47.9486273086035],
        [106.913723477756, 47.9486941821908],
        [106.913705183747, 47.9489805685984],
        [106.913723243033, 47.9492284829082],
        [106.9137378795, 47.9493837454635],
        [106.913872974758, 47.9499078289832],
        [106.914051279743, 47.9506375379921],
        [106.914143833471, 47.9509739249067],
        [106.914331486909, 47.9517154402154],
        [106.914424598217, 47.9520667711646],
        [106.914621047024, 47.9528051478393],
        [106.914728139192, 47.9532938088623],
        [106.914938247802, 47.9541605511686],
        [106.915046009965, 47.9546671437737],
        [106.915279950609, 47.9554557340949],
        [106.915435969494, 47.9560632000567],
        [106.915699160588, 47.9569200821961],
        [106.915833274686, 47.9575368849194],
        [106.916031617465, 47.9584456876185],
        [106.916341485171, 47.9596008425049],
        [106.916640699509, 47.9607083261284],
        [106.916745176449, 47.9611252572249],
        [106.916951812776, 47.961896354833],
        [106.917109865028, 47.9625576137429],
        [106.91722065431, 47.9631448980187],
        [106.917270882345, 47.9634191876454],
        [106.917319759599, 47.963777235631],
        [106.917344173495, 47.9640758815967],
        [106.917311881538, 47.9647672327217],
        [106.917320193972, 47.9654728587855],
        [106.917303293013, 47.9659785412767],
        [106.917287670889, 47.9667593308785],
        [106.917263392791, 47.9674266224407],
        [106.917222690375, 47.9678908344945],
        [106.917195376166, 47.9687166765335],
        [106.917179444676, 47.9693688774718],
        [106.917179520219, 47.970092583506],
        [106.917188902846, 47.9704662437222],
        [106.917203423299, 47.970738140253],
        [106.917281863967, 47.9712930678209],
        [106.917387233034, 47.9718535271186],
        [106.917595364934, 47.9726634745398],
        [106.917732669827, 47.9732443340588],
        [106.917886119349, 47.9737800655976],
        [106.917936693624, 47.9740633205658],
        [106.918174207274, 47.9749445491517],
        [106.918261500868, 47.9752570959383],
        [106.918350830526, 47.9753841962237],
        [106.918570234529, 47.975536037758],
        [106.918747144665, 47.9756227980537],
        [106.919153269508, 47.9757655366503],
        [106.919709732218, 47.9758788458321],
        [106.920800632343, 47.9761118062149],
        [106.922160266983, 47.9763851155807],
        [106.923214912738, 47.9766007154507],
        [106.924206476448, 47.9767964313103],
        [106.924940599329, 47.9769110238247],
        [106.92602777716, 47.9770277783094],
        [106.925975674937, 47.9771273035822],
        [106.925922020485, 47.9772288981952],
        [106.925885986449, 47.977289490018],
        [106.925873866286, 47.9773195966221],
        [106.925862944919, 47.9773562916596],
        [106.925849868776, 47.9774336387515],
        [106.92583681152, 47.9774989025524],
        [106.925825231849, 47.9775433146723],
        [106.925809155568, 47.9775899328292],
        [106.925787441437, 47.9776425009007],
        [106.925739925757, 47.9777375637376],
        [106.925688902721, 47.9778241171893],
        [106.925689150934, 47.9778840408159],
        [106.925696697145, 47.9779153381224],
        [106.92569377255, 47.9779510978649],
        [106.925682131725, 47.9779812890054],
        [106.925683034644, 47.9780055563114],
        [106.925679897809, 47.978035605359],
        [106.925676867094, 47.978068509754],
        [106.925671657321, 47.9781000210991],
        [106.925661503076, 47.9781701826079],
        [106.925653572854, 47.9782467670747],
        [106.92567890136, 47.9783119436414],
        [106.925703554476, 47.978384657426],
        [106.925765569026, 47.9785983885049],
        [106.925789488294, 47.9786773237995],
        [106.925798807969, 47.9787199498658],
        [106.925804546543, 47.9787884107566],
        [106.925803912521, 47.9788254817106],
        [106.925800717229, 47.978857032626],
        [106.925793549633, 47.9788965452394],
        [106.925784053691, 47.9789237281476],
        [106.925763005958, 47.9789583592409],
        [106.925735660273, 47.9789952386394],
        [106.925711423543, 47.9790299245914],
        [106.925704422321, 47.9790474838544],
        [106.925700022838, 47.9790665368912],
        [106.925701774717, 47.979113640682],
        [106.925703765816, 47.9791671674309],
        [106.925714260905, 47.9792267106442],
        [106.925745056389, 47.9793335851768],
        [106.925759803472, 47.9793868978871],
        [106.925771122339, 47.9794338415986],
        [106.925771963206, 47.9794572968169],
        [106.925769687021, 47.979481000248],
        [106.925755493921, 47.9795283702381],
        [106.925744092316, 47.979564982538],
        [106.925745526735, 47.9796035229842],
        [106.925753337347, 47.9796419546126],
        [106.925764656214, 47.9796888992234],
        [106.925785702149, 47.9797399636284],
        [106.925823807323, 47.9798207371373],
        [106.9258761029, 47.9799398361546],
        [106.925911417478, 47.9800313682531],
        [106.925940752464, 47.9801337120012],
        [106.925956615605, 47.9802170009139],
        [106.925961685983, 47.9802622314169],
        [106.925968331973, 47.9803603456535],
        [106.925978851343, 47.9804715756028],
        [106.925980100501, 47.9805385040488],
        [106.925977572507, 47.9806087132216],
        [106.925973185614, 47.9806623469898],
        [106.925965850743, 47.9807224576753],
        [106.925951976902, 47.980778393708],
        [106.925914742272, 47.980892566239],
        [106.925896606543, 47.9809603085714],
        [106.925860079679, 47.981128107676],
        [106.925840190273, 47.9812044682117],
        [106.925817386163, 47.9812776928113],
        [106.925803274901, 47.9813272058859],
        [106.925795459793, 47.981374469756],
        [106.925794424673, 47.9814154716467],
        [106.92579944289, 47.9814815250524],
        [106.925804623884, 47.9815349978419],
        [106.925799997772, 47.9815822086521],
        [106.925788914527, 47.981627386095],
        [106.925763479901, 47.9817156518559],
        [106.925739560632, 47.9817829706076],
        [106.925687813642, 47.9819118812284],
        [106.925633076405, 47.9820475178787],
        [106.925609116667, 47.9821124471318],
        [106.925573738238, 47.9822307340612],
        [106.925530736255, 47.9824072727775],
        [106.925516496389, 47.9824622051667],
        [106.925511519541, 47.9824911498467],
        [106.925510161565, 47.9825404479834],
        [106.925511674224, 47.9825811288161],
        [106.925516306632, 47.9826004489516],
        [106.92552251735, 47.9826152257121],
        [106.925533040318, 47.9826297560584],
        [106.925555841729, 47.9826532310618],
        [106.925612047558, 47.9827058476968],
        [106.925663332297, 47.9827481787855],
        [106.925776362689, 47.9828337807544],
        [106.925876935672, 47.9829156208593],
        [106.925927603476, 47.9829533627076],
        [106.926028936386, 47.983018077922],
        [106.926084585535, 47.9830557082544],
        [106.926107251149, 47.983074754996],
        [106.92612093973, 47.9830893770731],
        [106.926131804439, 47.9831052483086],
        [106.926138000768, 47.9831190852776],
        [106.926140053021, 47.9831323017144],
        [106.926139276906, 47.983153342253],
        [106.926134252394, 47.9831898466342],
        [106.926120378553, 47.9832457835661],
        [106.926106185452, 47.9832931544556],
        [106.926101241879, 47.9833318010218],
        [106.926103620586, 47.9833499844143],
        [106.92610897425, 47.983368093163],
        [106.926116820835, 47.9833844338446],
        [106.926129464403, 47.9834041712655],
        [106.926159521545, 47.9834400874901],
        [106.926178657319, 47.983457068489],
        [106.926208872741, 47.9834799661276],
        [106.926244909475, 47.9835050707025],
        [106.926300160224, 47.9835319946059],
        [106.926361950843, 47.9835630949609],
        [106.926414331856, 47.9835986370675],
        [106.926453796805, 47.9836301106412],
        [106.92649606674, 47.9836595247673],
        [106.926512875969, 47.9836741108716],
        [106.926524554565, 47.9836881286043],
        [106.926539823254, 47.9837122214419],
        [106.926560313408, 47.9837482995445],
        [106.926583832478, 47.9837800420154],
        [106.926616840295, 47.9838094822219],
        [106.926669142167, 47.9838428830427],
        [106.926726761731, 47.983875497856],
        [106.926786344514, 47.9839051889733],
        [106.9268376994, 47.9839286378964],
        [106.92687388722, 47.9839422842091],
        [106.926925470534, 47.9839564152564],
        [106.92697362833, 47.983964177305],
        [106.927018435253, 47.9839677089427],
        [106.927057024262, 47.9839756319699],
        [106.927102152243, 47.9839877287507],
        [106.927123901447, 47.9839975475488],
        [106.927160752966, 47.9840188821657],
        [106.927214135824, 47.9840485975648],
        [106.927245584216, 47.9840688754783],
        [106.927278774596, 47.9840958038783],
        [106.927318218861, 47.98413407183],
        [106.927347935159, 47.9841655804772],
        [106.927369298554, 47.9841917741311],
        [106.927388461309, 47.984220011944],
        [106.927403264149, 47.9842469070692],
        [106.927414163033, 47.9842719684766],
        [106.927420964606, 47.984293742862],
        [106.927425987319, 47.9843429348786],
        [106.927427662756, 47.9843878982829],
        [106.927432365311, 47.9844285242571],
        [106.92744026046, 47.9844690980705],
        [106.927451023546, 47.9845010536807],
        [106.927460981739, 47.9845212020918],
        [106.927471514599, 47.984537130884],
        [106.927486760805, 47.9845542404859],
        [106.927521186853, 47.984585572866],
        [106.927666616221, 47.984720245443],
        [106.927770137182, 47.9848110706744],
        [106.928062165936, 47.9850585362225],
        [106.928207871396, 47.9851892850575],
        [106.928623242169, 47.9855710319776],
        [106.928767739839, 47.9856995298095],
        [106.928830858757, 47.9857607124869],
        [106.928900310701, 47.9858315619771],
        [106.928982339663, 47.9859191424545],
        [106.929051170175, 47.9859975651356],
        [106.929137232597, 47.9861038569075],
        [106.9292076675, 47.9862006077719],
        [106.929257317271, 47.9862769008583],
        [106.929275267739, 47.9863091082788],
        [106.929284853613, 47.9863307126923],
        [106.929294742558, 47.9863676820229],
        [106.929296338855, 47.9864105041415],
        [106.929290642549, 47.9864538946316],
        [106.929280120481, 47.9864926347274],
        [106.929257696785, 47.9865331815611],
        [106.929237425167, 47.9865672658667],
        [106.929231507628, 47.9866011091539],
        [106.92923276488, 47.9866348301334],
        [106.929241257178, 47.9866700376921],
        [106.929254833344, 47.9867131934591],
        [106.929276004284, 47.9867674702426],
        [106.929301960517, 47.9868216651877],
        [106.92932486535, 47.9868582370181],
        [106.92935757729, 47.9869010717271],
        [106.929392682326, 47.9869438659667],
        [106.929423360899, 47.9869753485336],
        [106.929486992431, 47.987033870117],
        [106.929621657813, 47.9871601547174],
        [106.929732425511, 47.9872611269994],
        [106.929821533937, 47.9873399705632],
        [106.929873921245, 47.9873969354203],
        [106.929921286738, 47.9874475582583],
        [106.929964628665, 47.9875079783106],
        [106.930023106181, 47.9875926908501],
        [106.930064696229, 47.9876555390719],
        [106.930086474211, 47.9876944626294],
        [106.930109867377, 47.987751199958],
        [106.930145910405, 47.987804869699],
        [106.930208959176, 47.9878980754359],
        [106.930244436532, 47.987949301719],
        [106.930267224453, 47.9879770799783],
        [106.930291444994, 47.9880008121878],
        [106.930328890966, 47.9880331751909],
        [106.930387606803, 47.9880775549353],
        [106.930407778596, 47.9880946924162],
        [106.930433722239, 47.9881223105962],
        [106.930470084527, 47.9881679170158],
        [106.930510381349, 47.9882215139118],
        [106.930524432357, 47.9882479989461],
        [106.930538133528, 47.9882810346421],
        [106.930557806198, 47.9883521188552],
        [106.930567220301, 47.9883993899199],
        [106.93057418555, 47.9884489668464],
        [106.930578502296, 47.9885005564556],
        [106.930578756804, 47.9885580204364],
        [106.930564686012, 47.9887586672787],
        [106.930563154466, 47.9888376439422],
        [106.930566243637, 47.9889204328318],
        [106.930572838366, 47.9889831668397],
        [106.930581131914, 47.9890307850428],
        [106.930592378835, 47.9890755865691],
        [106.930606016155, 47.989120347626],
        [106.930624078139, 47.9891553942061],
        [106.930637657902, 47.9891985499731],
        [106.930643580837, 47.9892289794339],
        [106.93064247557, 47.9892495280433],
        [106.930633894239, 47.9892902016815],
        [106.930620206557, 47.9893723799315],
        [106.930611380611, 47.9894244848521],
        [106.930604065525, 47.9894529915624],
        [106.930586545833, 47.9894966698355],
        [106.930563942272, 47.9895323999004],
        [106.930549461389, 47.9895487738569],
        [106.930536255744, 47.989560181757],
        [106.930503424194, 47.9895784092163],
        [106.93045851295, 47.9895936248459],
        [106.930420717142, 47.989607115576],
        [106.930383102998, 47.9896254230749],
        [106.93035989959, 47.9896450948453],
        [106.930341781848, 47.989672714824],
        [106.930326413333, 47.9897099296696],
        [106.930321758442, 47.9897375244672],
        [106.930317454287, 47.9897665195093],
        [106.930311177019, 47.9897907274602],
        [106.930297542398, 47.9898102391513],
        [106.930280320381, 47.9898298101976],
        [106.930266597625, 47.989846912605],
        [106.930262158572, 47.9898722950704],
        [106.930264134382, 47.9899252858233],
        [106.930262126196, 47.990002621224],
        [106.930264725237, 47.9900373521422],
        [106.93026916519, 47.9900601742377],
        [106.930281190025, 47.9900937144534],
        [106.930298953434, 47.9901368009727],
        [106.930318198026, 47.9901714257707],
        [106.930340760218, 47.990198762463],
        [106.930364803593, 47.9902176410313],
        [106.930396067624, 47.9902376032828],
        [106.930487930674, 47.9902939035409],
        [106.930531933602, 47.9903184712205],
        [106.930561402587, 47.9903384631496],
        [106.930587329142, 47.9903597177268],
        [106.930616890757, 47.9903804524959],
        [106.930641014171, 47.9903958551846],
        [106.930669767296, 47.9904090725207],
        [106.930714330502, 47.9904251856738],
        [106.930800431595, 47.9904606252577],
        [106.930878807511, 47.9904993554609],
        [106.93096188958, 47.9905380056245],
        [106.931025868249, 47.990569601506],
        [106.931077217739, 47.9905993007172],
        [106.93112848719, 47.9906268937162],
        [106.931173679022, 47.9906598592651],
        [106.931201294504, 47.9906846877482],
        [106.9312193403, 47.9907054629868],
        [106.93123130668, 47.9907316089766],
        [106.93123687798, 47.9907547008688],
        [106.931242371938, 47.9907756865488],
        [106.931247785857, 47.9907945660165],
        [106.9312583403, 47.9908249505111],
        [106.931276975152, 47.9908615250394],
        [106.931298788209, 47.9908990978151],
        [106.931320443883, 47.9909324590658],
        [106.931353514653, 47.990977221022],
        [106.931381367556, 47.991008369041],
        [106.931396235148, 47.9910281424349],
        [106.931407965905, 47.991047969788],
        [106.931415263903, 47.9910752480243],
        [106.931420235356, 47.9911043554817],
        [106.931422094254, 47.9911320438088],
        [106.931418998788, 47.9911753056958],
        [106.931407748269, 47.9912524297559],
        [106.931384694148, 47.9913919325917],
        [106.931379440309, 47.9914194230679],
        [106.931370930924, 47.991443804588],
        [106.931360812651, 47.9914671617801],
        [106.931349561233, 47.9914826328173],
        [106.931327709506, 47.991505659059],
        [106.931283699383, 47.9915464469111],
        [106.931210548528, 47.9916056420868],
        [106.931117037921, 47.9916662330103],
        [106.931057338226, 47.991707285263],
        [106.93102227276, 47.9917352757624],
        [106.930987244166, 47.9917643211665],
        [106.930952414323, 47.9917986312019],
        [106.930893305482, 47.991855481845],
        [106.930849871824, 47.991897665445],
        [106.930822453294, 47.9919202591127],
        [106.93080119332, 47.9919395855435],
        [106.930786171944, 47.9919577554461],
        [106.93077134662, 47.9919811908793],
        [106.930759736373, 47.9920066794647],
        [106.930751186518, 47.9920300087779],
        [106.930742793145, 47.9920575514149],
        [106.930725459612, 47.9920978905053],
        [106.930711752146, 47.9921223142934],
        [106.930698787519, 47.9921404958872],
        [106.930671566839, 47.9921683550856],
        [106.930658191223, 47.9921886042208],
        [106.930644817404, 47.9922088524567],
        [106.930634697333, 47.9922322087495],
        [106.930618303592, 47.9922556711623],
        [106.930587903809, 47.9922825285159],
        [106.930536284522, 47.9923297681044],
        [106.930510278826, 47.9923481214687],
        [106.930482702914, 47.9923665009133],
        [106.930453205151, 47.9923754284833],
        [106.930412684398, 47.9923834873081],
        [106.930364436669, 47.9923948376517],
        [106.9303178356, 47.9924082672278],
        [106.930282256621, 47.992422565549],
        [106.930226909644, 47.9924540598071],
        [106.930160696159, 47.9924888977445],
        [106.930098475664, 47.9925242482955],
        [106.930039332649, 47.9925604945712],
        [106.929976850451, 47.9926014676836],
        [106.929930638788, 47.9926350411742],
        [106.929868233033, 47.9926877306543],
        [106.9298241033, 47.9927253591881],
        [106.929795233263, 47.9927511382545],
        [106.929774169343, 47.9927757311152],
        [106.929742593246, 47.9928131492075],
        [106.929721609365, 47.9928398491797],
        [106.929697839384, 47.9928760810663],
        [106.929669676215, 47.9929208187409],
        [106.92965198655, 47.9929516780775],
        [106.92964198429, 47.9929781945881],
        [106.929636533499, 47.9930004177351],
        [106.929633201511, 47.9930373600861],
        [106.929634968679, 47.9930847561566],
        [106.929639206284, 47.9931141936652],
        [106.929645092347, 47.9931457122049],
        [106.929653959663, 47.9931729652602],
        [106.929683304541, 47.9932441367076],
        [106.929701834172, 47.9932943026899],
        [106.929711553146, 47.9933279742067],
        [106.929719171303, 47.9933708799622],
        [106.929722364795, 47.9934003354572],
        [106.929729636713, 47.9934269131216],
        [106.929741039218, 47.9934520149985],
        [106.929761440338, 47.9934938280778],
        [106.929780272142, 47.9935497191442],
        [106.929796332235, 47.9935873899461],
        [106.929803865856, 47.9936209877185],
        [106.929808385848, 47.9936356070976],
        [106.929813072216, 47.9936433160862],
        [106.929832425626, 47.9936570424386],
        [106.929864383934, 47.99367196399],
        [106.929906803156, 47.9936867074756],
        [106.929942789528, 47.9936973446568],
        [106.929972707275, 47.9937137051235],
        [106.929992113745, 47.9937288344182],
        [106.930009741357, 47.9937524281321],
        [106.930025538848, 47.9937830761281],
        [106.930044005526, 47.9938291367054],
        [106.930053474488, 47.9938584869797],
        [106.930064929153, 47.9938849935976],
        [106.930080412781, 47.9939072158454],
        [106.930106619925, 47.9939362855312],
        [106.930132929591, 47.9939681620011],
        [106.93015322639, 47.9940071682962],
        [106.930165259319, 47.9940491207703],
        [106.930170963719, 47.9940897755227],
        [106.930176352457, 47.9941535221674],
        [106.93017515456, 47.9942021215307],
        [106.930170188503, 47.9942373344854],
        [106.930161246544, 47.9942782356521],
        [106.930148016618, 47.9943163992825],
        [106.930128298982, 47.9943490500687],
        [106.93009613383, 47.9943847207783],
        [106.930029134337, 47.9944406496164],
        [106.929937763217, 47.994516661215],
        [106.929866422697, 47.9945684468764],
        [106.92982049432, 47.9945966469178],
        [106.92978237116, 47.994616231454],
        [106.929742660695, 47.9946320936962],
        [106.929687336202, 47.9946501475863],
        [106.929577445343, 47.9946786938667],
        [106.929455000848, 47.9947074496891],
        [106.92929751247, 47.9947508464745],
        [106.929195816234, 47.9947791976019],
        [106.929140128414, 47.9947970518425],
        [106.929041116654, 47.9948366561868],
        [106.928925629314, 47.9948835630261],
        [106.928810350617, 47.9949360861315],
        [106.928761480558, 47.9949605971539],
        [106.928730273184, 47.9949781806985],
        [106.928664997692, 47.995024244873],
        [106.928565201723, 47.9950989911256],
        [106.928489622698, 47.9951494421931],
        [106.928397357652, 47.99520157859],
        [106.928352270141, 47.9952276292518],
        [106.928300960221, 47.9952551898751],
        [106.928258121915, 47.9952854187871],
        [106.928237573305, 47.9953039097477],
        [106.92822381098, 47.9953197198292],
        [106.928208119609, 47.9953480880439],
        [106.928200745168, 47.9953749094246],
        [106.928199385393, 47.9953946045774],
        [106.92820006618, 47.9954128617143],
        [106.928205401858, 47.9954436859774],
        [106.928214504796, 47.9954632057624],
        [106.928229725821, 47.9954784088016],
        [106.92824892275, 47.9954879218302],
        [106.928264038555, 47.995500314488],
        [106.928277219918, 47.9955169555431],
        [106.928284438776, 47.9955421275672],
        [106.928291866277, 47.9955729176561],
        [106.928299191255, 47.9956008991622],
        [106.928354335884, 47.9956218524666],
        [106.928385670962, 47.9956251349921],
        [106.928426150347, 47.9956454048116],
        [106.928472443848, 47.9956693861333],
        [106.928510017523, 47.9956878006515],
        [106.928584667548, 47.9957113053325],
        [106.928645139761, 47.9957350492332],
        [106.928765515816, 47.9957673088143],
        [106.928871784206, 47.9958017096812],
        [106.928940337726, 47.9958138891997],
        [106.92897216923, 47.9958304951813],
        [106.929012436375, 47.9958450552052],
        [106.92907574415, 47.9958687505425],
        [106.929192647023, 47.9958839275013],
        [106.929266800622, 47.9958941087262],
        [106.929346484153, 47.9959003877927],
        [106.929440417441, 47.9959083324036],
        [106.929525630004, 47.9959107093118],
        [106.92966224062, 47.995921745792],
        [106.929752475896, 47.9959474583086],
        [106.929833968863, 47.9959432791591],
        [106.92990065719, 47.9959351322006],
        [106.929933924011, 47.9959289520596],
        [106.929969072215, 47.9959171196794],
        [106.930000088933, 47.9959067621874],
        [106.930050041776, 47.9958988958174],
        [106.930100097142, 47.9958938389296],
        [106.930162707943, 47.9958885716003],
        [106.930219093636, 47.9958848124342],
        [106.930265176697, 47.9958854437583],
        [106.930307229895, 47.9958903567546],
        [106.930347349551, 47.9958995199469],
        [106.930385743407, 47.9959185469034],
        [106.930451964986, 47.9959539685009],
        [106.930482821625, 47.9959724135961],
        [106.9305012928, 47.995985460061],
        [106.930519935746, 47.996002084029],
        [106.930536078577, 47.9960200039201],
        [106.93054912774, 47.9960398267766],
        [106.930565268772, 47.9960729110361],
        [106.930595350195, 47.996149691555],
        [106.930616834999, 47.9962128725261],
        [106.930635687487, 47.9962768871687],
        [106.930645471212, 47.9963146622919],
        [106.930652120799, 47.9963805951884],
        [106.930654425761, 47.9964423858075],
        [106.930652184651, 47.9965506237124],
        [106.93063655893, 47.9967490195517],
        [106.930630653982, 47.9968151628895],
        [106.930622445869, 47.9968757250347],
        [106.930596717165, 47.996971710576],
        [106.930557758534, 47.9971058597477],
        [106.930524703952, 47.9972028417378],
        [106.930493171922, 47.9972825954155],
        [106.930462209164, 47.9973505661757],
        [106.93044463731, 47.9973845857301],
        [106.930428789457, 47.9974087406209],
        [106.930412627741, 47.9974244688642],
        [106.930386004211, 47.9974403742739],
        [106.930361577725, 47.9974590531928],
        [106.930335426339, 47.9974875958759],
        [106.930321618148, 47.9975103118514],
        [106.930303730633, 47.9975359056576],
        [106.930294002666, 47.997555742004],
        [106.930284906024, 47.9975854915772],
        [106.930273400997, 47.9976137887454],
        [106.930245155989, 47.9976423683007],
        [106.930166228788, 47.9977153599759],
        [106.930050791811, 47.9978198800834],
        [106.929997834333, 47.9978749626595],
        [106.929974113814, 47.9978970500089],
        [106.929955523029, 47.9979134185694],
        [106.929943618703, 47.9979214495153],
        [106.929914745969, 47.9979331766748],
        [106.929879436787, 47.9979407966305],
        [106.929810548718, 47.9979461700797],
        [106.92973972261, 47.9979557919263],
        [106.929692018972, 47.9979678347478],
        [106.929644577036, 47.9979868985766],
        [106.929609740897, 47.9980071576043],
        [106.929568837032, 47.9980331381189],
        [106.929505650665, 47.9980791672198],
        [106.929450362145, 47.9981124160552],
        [106.929396440593, 47.998147221617],
        [106.929355210275, 47.9981784775548],
        [106.929321786971, 47.9982085490853],
        [106.929291501402, 47.9982385666566],
        [106.929264511848, 47.9982727444916],
        [106.929239051141, 47.9983058440395],
        [106.929216691297, 47.9983378356227],
        [106.929202217608, 47.9983707499102],
        [106.92918950749, 47.998408903648],
        [106.929174445644, 47.9984681761654],
        [106.929162915436, 47.998537926684],
        [106.929153188369, 47.9986139706583],
        [106.9291535454, 47.9987077618538],
        [106.929155589559, 47.9987625296671],
        [106.929158571711, 47.9988004208028],
        [106.929166499235, 47.9988445514349],
        [106.929185920994, 47.9989021898842],
        [106.929201301199, 47.9989356554562],
        [106.929224371508, 47.998964778202],
        [106.929252306249, 47.9989980324333],
        [106.929299858802, 47.9990520367222],
        [106.929345879809, 47.9991071201975],
        [106.929370676815, 47.9991404292874],
        [106.929395550264, 47.999175842791],
        [106.929419013577, 47.999215496598],
        [106.929432903606, 47.9992510962611],
        [106.929446754964, 47.9992856428182],
        [106.929463861868, 47.9993232947343],
        [106.92949375893, 47.9993670557451],
        [106.929535034214, 47.9994211652546],
        [106.929563362859, 47.9994649541443],
        [106.929583568827, 47.9995014998943],
        [106.929595457864, 47.9995255405713],
        [106.929602441999, 47.9995443930594],
        [106.929612486527, 47.9995610871745],
        [106.929625670588, 47.9995777282296],
        [106.929640382598, 47.999593289199],
        [106.92965827371, 47.9996098502145],
        [106.929679588542, 47.9996252556011],
        [106.929729050355, 47.9996550330534],
        [106.929828901183, 47.9997218580774],
        [106.929872531792, 47.9997479716916],
        [106.929904308437, 47.9997648546644],
        [106.929933067857, 47.9997780720005],
        [106.929950604637, 47.9997851550609],
        [106.929974380014, 47.9997910788952],
        [106.930014005942, 47.9998009507534],
        [106.930063046872, 47.9998106670287],
        [106.930121660187, 47.9998244356492],
        [106.930193144598, 47.9998464195767],
        [106.930272513366, 47.9998693262085],
        [106.930326655251, 47.9998894935053],
        [106.930374638579, 47.9999129271399],
        [106.930422192031, 47.9999386270661],
        [106.930464484448, 47.9999641111548],
        [106.930511213222, 47.999995996618],
        [106.930541815353, 48.0000165596166],
        [106.930562806428, 48.0000320162646],
        [106.930579208264, 48.0000507095726],
        [106.930583225535, 48.0000607415101],
        [106.930586546732, 48.0000790418144],
        [106.930590746566, 48.0001074262168],
        [106.930598284683, 48.0001873714501],
        [106.93060335596, 48.0003190474861],
        [106.930604299349, 48.0003443256302],
        [106.930601867582, 48.0003633372982],
        [106.930593080306, 48.0003803479747],
        [106.930577859281, 48.0003932496488],
        [106.930541061721, 48.0004170547033],
        [106.93044400149, 48.0004671649278],
        [106.930358086557, 48.0005213050143],
        [106.93027993637, 48.0005732057889],
        [106.930221875239, 48.0006163381735],
        [106.930165225145, 48.0006552302547],
        [106.930090332303, 48.000710238187],
        [106.930011045374, 48.0007737510078],
        [106.929948392305, 48.0008201218512],
        [106.929857103023, 48.0008985894984],
        [106.929796293564, 48.0009523069035],
        [106.929755257499, 48.0009888292711],
        [106.929726461207, 48.0010167145498],
        [106.929703943982, 48.0010444937085],
        [106.929687623985, 48.0010700632329],
        [106.929672992015, 48.0010987641967],
        [106.929661654262, 48.0011316236256],
        [106.929656556905, 48.0011633274257],
        [106.929654674624, 48.0011970834787],
        [106.929659425742, 48.0012402140647],
        [106.929671277907, 48.0013053555577],
        [106.929680930331, 48.0013536734333],
        [106.929693213271, 48.0013882460707],
        [106.929708594376, 48.0014217116427],
        [106.929725311874, 48.0014505600953],
        [106.929753639619, 48.0014926195888],
        [106.929801626544, 48.0015582098435],
        [106.929857734347, 48.0016310396408],
        [106.92991211725, 48.0016996830939],
        [106.92994652801, 48.0017380985345],
        [106.929975837815, 48.0017660620542],
        [106.930009620847, 48.0017876259982],
        [106.930048031791, 48.0018070045896],
        [106.930097506195, 48.001828304133],
        [106.930196182508, 48.0018635332755],
        [106.930313848905, 48.0019026564825],
        [106.930402872794, 48.001931722571],
        [106.930480871895, 48.0019599208138],
        [106.930530269856, 48.0019791150441],
        [106.9305798243, 48.0020025216991],
        [106.930607053972, 48.0020168182216],
        [106.930642012419, 48.0020278232255],
        [106.930697490697, 48.0020416458054],
        [106.930773489705, 48.0020582841626],
        [106.930857608692, 48.0020821629615],
        [106.930959227586, 48.0021120708155],
        [106.931019735772, 48.0021273889679],
        [106.931078796949, 48.0021390432823],
        [106.93112702849, 48.0021410415758],
        [106.931156624279, 48.0021406287871],
        [106.931177196271, 48.0021387932708],
        [106.931220772021, 48.0021282235388],
        [106.931282759592, 48.0021061038137],
        [106.931344486359, 48.0020769612828],
        [106.931389681788, 48.0020537183045],
        [106.931426559388, 48.0020320194622],
        [106.931450934613, 48.0020119367016],
        [106.931466730305, 48.001986377969],
        [106.931476039188, 48.0019553072917],
        [106.931483151926, 48.0019214631051],
        [106.931490524568, 48.0018946399258],
        [106.931500148213, 48.0018719949966],
        [106.931513956404, 48.0018492790211],
        [106.931538226408, 48.0018263876777],
        [106.931572908763, 48.0018019162255],
        [106.931597377517, 48.0017890136521],
        [106.931628460785, 48.001775687498],
        [106.931705043453, 48.0017519157184],
        [106.931781677383, 48.0017295495791],
        [106.931848060839, 48.0017129759731],
        [106.931914652939, 48.0017020186333],
        [106.931962621878, 48.0016969959197],
        [106.932014985803, 48.0016975202244],
        [106.932041668688, 48.0017004169408],
        [106.932092879683, 48.0017088570781],
        [106.93219185547, 48.0017240529228],
        [106.932246522559, 48.0017301602188],
        [106.932301084428, 48.0017334571334],
        [106.932370135274, 48.0017322952093],
        [106.932428777366, 48.0017327142934],
        [106.932465298835, 48.0017363187761],
        [106.932487999522, 48.0017422228254],
        [106.932501621553, 48.001755824172],
        [106.932511827959, 48.0017782829415],
        [106.932518476646, 48.0018058309744],
        [106.932527045387, 48.0018346047833],
        [106.932539405669, 48.0018645710931],
        [106.932557382217, 48.0018944438735],
        [106.932599046009, 48.0019566059127],
        [106.932617163751, 48.0019902477518],
        [106.932629383739, 48.002016445003],
        [106.932634019744, 48.0020402545542],
        [106.932635239225, 48.0020729242261],
        [106.932630521381, 48.0021471821468],
        [106.93262795022, 48.0021786566198],
        [106.93262322698, 48.0022026262503],
        [106.932609045571, 48.0022242378583],
        [106.932587565264, 48.0022510016824],
        [106.932552331625, 48.0022888676372],
        [106.932470142583, 48.002367390143],
        [106.932444870734, 48.0023929605667],
        [106.932428818735, 48.0024146045504],
        [106.932416746236, 48.0024424682454],
        [106.932405377906, 48.0024891790325],
        [106.9323918548, 48.0025283822791],
        [106.93238563329, 48.0025624333097],
        [106.932386572183, 48.0025875630656],
        [106.932395093259, 48.0026150787229],
        [106.932409279165, 48.002643758103],
        [106.932435355907, 48.0026898384653],
        [106.932473826206, 48.0027463419702],
        [106.932560963318, 48.0028555052774],
        [106.932595035932, 48.0029021459173],
        [106.93263080197, 48.0029568642679],
        [106.932648920611, 48.0029905052077],
        [106.932661327658, 48.0030217278705],
        [106.932666151622, 48.0030505646319],
        [106.932665922295, 48.0030945738555],
        [106.932661902325, 48.0031373887795],
        [106.932652218425, 48.0031790417794],
        [106.932642486861, 48.0032194375271],
        [106.932623395154, 48.0032599924547],
        [106.932598776213, 48.003309180874],
        [106.932579639539, 48.0033424521924],
        [106.932522590145, 48.0034201059532],
        [106.932453187665, 48.0035180834928],
        [106.932431988845, 48.003552387233],
        [106.932414391811, 48.0035828580625],
        [106.932404238465, 48.0036119457347],
        [106.932394459237, 48.0036510860289],
        [106.93239015778, 48.0036863619361],
        [106.932381735629, 48.0037116499727],
        [106.9323639983, 48.0037383508443],
        [106.932342496409, 48.0037669870568],
        [106.932322814746, 48.003789336109],
        [106.932284763531, 48.0038239222363],
        [106.932233795353, 48.0038637550083],
        [106.932166868706, 48.0039277444699],
        [106.932118147035, 48.0039775974882],
        [106.932082437654, 48.0040247192654],
        [106.932052252809, 48.0040692312101],
        [106.932038305224, 48.004097125482],
        [106.932033581984, 48.0041210942132],
        [106.932038311519, 48.0041474164702],
        [106.932050530608, 48.0041736137214],
        [106.932064528555, 48.0041972667905],
        [106.932092102668, 48.004233263954],
        [106.9321256213, 48.0042779611591],
        [106.932151510983, 48.0043190170091],
        [106.932201040246, 48.0043911048657],
        [106.932222761571, 48.0044209137942],
        [106.932246028831, 48.0044418967761],
        [106.932271212546, 48.0044641037355],
        [106.932296211001, 48.0044812852831],
        [106.932327012781, 48.0045033978136],
        [106.932367597387, 48.0045366619374],
        [106.932439407353, 48.0046033457678],
        [106.932521097271, 48.0046836938974],
        [106.932579567593, 48.0047443171965],
        [106.93260787915, 48.0047780327801],
        [106.932628722737, 48.0048063524313],
        [106.93264699876, 48.0048357980337],
        [106.932662806144, 48.004866128569],
        [106.93267928622, 48.0049060845482],
        [106.932691553872, 48.0049335381523],
        [106.932703540036, 48.0049534518404],
        [106.932719315944, 48.0049745607275],
        [106.932744501458, 48.0049967676868],
        [106.932779095679, 48.0050200736176],
        [106.932800489651, 48.0050410871765],
        [106.932818044417, 48.0050596509822],
        [106.93282623814, 48.0050783721692],
        [106.932829251769, 48.0050970726718],
        [106.932828022395, 48.0051261189753],
        [106.932822083273, 48.0051677090226],
        [106.932812680861, 48.0052169010392],
        [106.932804680492, 48.0052534971512],
        [106.932794480381, 48.0052813275712],
        [106.932778474247, 48.0053042288072],
        [106.932762469013, 48.0053271291437],
        [106.932751845321, 48.0053436514884],
        [106.932743188447, 48.0053626568612],
        [106.932733127732, 48.0053942590379],
        [106.932720731477, 48.005463617452],
        [106.932716100867, 48.005490098889],
        [106.932705852193, 48.0055166738555],
        [106.932684559845, 48.0055484639905],
        [106.932661157686, 48.0055740029379],
        [106.932637614335, 48.0055957728267],
        [106.93260283845, 48.0056177315731],
        [106.932560432718, 48.0056360471659],
        [106.932514233645, 48.0056531702576],
        [106.932456660846, 48.005666712249],
        [106.932378491774, 48.00568059958],
        [106.932289276329, 48.0056997020796],
        [106.932153580324, 48.005728387755],
        [106.93207559921, 48.0057473031956],
        [106.932014609886, 48.0057697017104],
        [106.931951981998, 48.0057984161641],
        [106.931867309029, 48.005838815509],
        [106.931812311889, 48.0058711731162],
        [106.931757455942, 48.0059072988828],
        [106.931706484167, 48.0059471316549],
        [106.931635761481, 48.0060099286154],
        [106.931558517811, 48.0060871174266],
        [106.931473585837, 48.0061823889062],
        [106.931378713657, 48.0063009105587],
        [106.931317378994, 48.0063823468679],
        [106.931282579727, 48.006435798973],
        [106.931257060565, 48.0064828658916],
        [106.931239008474, 48.0065232841223],
        [106.931217295242, 48.00659405717],
        [106.931203244234, 48.0066425917822],
        [106.931197688223, 48.0066710796067],
        [106.931195194403, 48.0066993345067],
        [106.93119582123, 48.0067214020711],
        [106.931202704641, 48.0067552327678],
        [106.931211273382, 48.0067840065767],
        [106.931227566399, 48.0068189371443],
        [106.931257905028, 48.0068787762346],
        [106.931293954353, 48.0069410327026],
        [106.931341754219, 48.0070169228927],
        [106.931395218015, 48.007093975007],
        [106.931424994568, 48.0071387360639],
        [106.931458326141, 48.0071784087566],
        [106.931491706277, 48.0072193369029],
        [106.931513428502, 48.0072491467308],
        [106.931527568542, 48.0072765688586],
        [106.931542036836, 48.0073127854568],
        [106.931551215316, 48.0073578927526],
        [106.931553561648, 48.0074207175921],
        [106.931550713495, 48.0074949449358],
        [106.931547407587, 48.0075254022756],
        [106.931543181673, 48.0075441054761],
        [106.931535036513, 48.0075662710666],
        [106.931525865227, 48.0075821144231],
        [106.931514391676, 48.0075954531677],
        [106.93150059068, 48.0076076848468],
        [106.931460241697, 48.0076309952743],
        [106.931416195601, 48.0076556241078],
        [106.931381417918, 48.0076775828542],
        [106.931348512624, 48.0076995101243],
        [106.931338032824, 48.0077105331147],
        [106.931319866519, 48.0077351961224],
        [106.931291175447, 48.0077696248683],
        [106.93125307387, 48.0078029546427],
        [106.931211089021, 48.0078325783109],
        [106.93110113431, 48.0078985480796],
        [106.930980135025, 48.0079697330168],
        [106.930912262291, 48.0080085927224],
        [106.93087392689, 48.0080356398329],
        [106.930847654995, 48.0080559267397],
        [106.930832127301, 48.0080702889127],
        [106.930808911302, 48.0081008541711],
        [106.930792904269, 48.0081237536084],
        [106.930782796789, 48.0081540985329],
        [106.930778069952, 48.0081780654654],
        [106.930765901225, 48.0082034164545],
        [106.93075525685, 48.0082224425118],
        [106.930746430903, 48.0082339187604],
        [106.930733144319, 48.0082459471928],
        [106.930713665004, 48.0082596150892],
        [106.930665872332, 48.0082843068753],
        [106.930634890688, 48.0082988633019],
        [106.930614241354, 48.0083065480088],
        [106.930571503772, 48.008316068232],
        [106.930528624996, 48.0083218175978],
        [106.930468706765, 48.0083228248386],
        [106.93043884118, 48.008325842064],
        [106.930407197634, 48.0083314025722],
        [106.930364646212, 48.008345948207],
        [106.930314466739, 48.0083568497889],
        [106.930262178357, 48.0083615010824],
        [106.930219065757, 48.0083609677845],
        [106.930185221571, 48.0083577652987],
        [106.930160917392, 48.00835341258],
        [106.930150564397, 48.0083500239345],
        [106.929978093314, 48.0083035838434],
        [106.929851048787, 48.0082533971766],
        [106.929687844319, 48.0081697377432],
        [106.929477718622, 48.0080932998659],
        [106.929314979103, 48.0080693778995],
        [106.929145721298, 48.008098876562],
        [106.928921978067, 48.0081902207022],
        [106.928759670223, 48.0082538756159],
        [106.928739520912, 48.008322759188],
        [106.928882683089, 48.0085069493363],
        [106.929016220722, 48.0086373069662],
        [106.929178647277, 48.0088274695121],
        [106.929405712604, 48.0090933082097],
        [106.929466036429, 48.0092310564681],
        [106.929490427841, 48.0093111662774],
        [106.929496643955, 48.0093874494713],
        [106.92950551127, 48.0095062849871],
        [106.929466739698, 48.0096195842764],
        [106.929373533062, 48.0096883131651],
        [106.929199636554, 48.0097623588458],
        [106.929050926459, 48.0098190925771],
        [106.928937070489, 48.0098560358274],
        [106.928881268456, 48.0098707388436],
        [106.928755112459, 48.0099005819463],
        [106.928666447399, 48.0099245839525],
        [106.928623335698, 48.0099342282821],
        [106.928584356383, 48.009940502852],
        [106.928515199417, 48.0099486156362],
        [106.928408840196, 48.0099604597075],
        [106.928328510952, 48.0099668376994],
        [106.928253891504, 48.0099756348677],
        [106.928157036318, 48.0099910915157],
        [106.928075349997, 48.0100113217651],
        [106.927984486995, 48.0100367357068],
        [106.927946033783, 48.0100501365047],
        [106.927917966841, 48.010061740457],
        [106.927873868584, 48.0100851120383],
        [106.927833798391, 48.0101159587845],
        [106.927797799429, 48.0101555397464],
        [106.927751362935, 48.0102166675652],
        [106.927704739382, 48.0102727708717],
        [106.927673159689, 48.0103075242729],
        [106.927650577712, 48.0103277428311],
        [106.927614017573, 48.0103522448603],
        [106.927575630911, 48.0103780338193],
        [106.927540989925, 48.010403760725],
        [106.92751032754, 48.0104357082414],
        [106.927470771759, 48.0104803766681],
        [106.927407474775, 48.0105585457404],
        [106.927340378156, 48.0106351077241],
        [106.9273042389, 48.0106709187279],
        [106.927260358279, 48.0107001529897],
        [106.927203996867, 48.0107295976928],
        [106.927152501687, 48.0107556069857],
        [106.92711848483, 48.010781323999],
        [106.92710557776, 48.0107954325632],
        [106.927089836027, 48.0108170081984],
        [106.927054756172, 48.0108812980336],
        [106.926993775842, 48.0109879324472],
        [106.926935417036, 48.0110978754666],
        [106.926912327842, 48.0111518428833],
        [106.926892036438, 48.0112075675752],
        [106.92687659328, 48.011254067921],
        [106.926869878942, 48.0112833759271],
        [106.926866757395, 48.0113337199753],
        [106.926868996707, 48.0113597517512],
        [106.926873561666, 48.0113822195139],
        [106.926882092635, 48.0114075417247],
        [106.926892787372, 48.0114288349728],
        [106.926907175626, 48.0114483844354],
        [106.926931987022, 48.011475115884],
        [106.926958943301, 48.0115007168847],
        [106.926999149291, 48.0115343380393],
        [106.927173680721, 48.0115905708482],
        [106.927195309416, 48.0115997304433],
        [106.927249115854, 48.0116154919614],
        [106.927346091549, 48.0116471930635],
        [106.927439432184, 48.0116765748141],
        [106.927503186023, 48.0117186621866],
        [106.927532995851, 48.011725798307],
        [106.927561236362, 48.0117344506844],
        [106.927589703502, 48.0117453540649],
        [106.927622158236, 48.0117602495359],
        [106.927654816217, 48.0117781028772],
        [106.927703927294, 48.011809169058],
        [106.927771151617, 48.0118543518969],
        [106.9278450615, 48.0119090567576],
        [106.927904863719, 48.0119566183034],
        [106.9279584795, 48.0120027058603],
        [106.928013541392, 48.012052314263],
        [106.928043996933, 48.0120850891556],
        [106.928065896324, 48.0121144070543],
        [106.928081013928, 48.0121397868218],
        [106.928091911912, 48.0121653869231],
        [106.928100552599, 48.0121947794656],
        [106.928107045704, 48.012234903618],
        [106.928101117373, 48.01227691185],
        [106.928085576188, 48.0123291399779],
        [106.928060360997, 48.0123899125645],
        [106.928034644883, 48.0124372816553],
        [106.928015445257, 48.0124617890804],
        [106.927991513398, 48.01248662206],
        [106.927940581193, 48.0125277102857],
        [106.927898767214, 48.0125612855749],
        [106.92787248183, 48.0125774679758],
        [106.927842225938, 48.0125896079241],
        [106.927793521354, 48.0126039377216],
        [106.927741068396, 48.0126164679756],
        [106.927659630288, 48.0126313310711],
        [106.927599870338, 48.0126424035242],
        [106.927565251835, 48.0126463254676],
        [106.927523575453, 48.0126465781771],
        [106.927472683717, 48.0126428504872],
        [106.927432576652, 48.0126380597987],
        [106.92740233425, 48.0126322978423],
        [106.927344158906, 48.0126131566719],
        [106.927286169721, 48.012599043611],
        [106.92724366956, 48.0125924965465],
        [106.927188295603, 48.0125872750828],
        [106.927132066392, 48.0125846751427],
        [106.927053280385, 48.0125845114661],
        [106.926963306811, 48.0125871392851],
        [106.926841302984, 48.0125947736299],
        [106.926741666195, 48.0126031688013],
        [106.926587376706, 48.0126191506533],
        [106.92637589753, 48.012642813615],
        [106.926109549816, 48.0126690747181],
        [106.925927907447, 48.0126888849841],
        [106.925823353165, 48.0126990194443],
        [106.925739023737, 48.0127155220038],
        [106.925654880468, 48.0127370490756],
        [106.925551199428, 48.0127706378547],
        [106.925450265817, 48.0128108870129],
        [106.925379806633, 48.0128430080984],
        [106.925325110765, 48.0128716587001],
        [106.92528289479, 48.0128973981964],
        [106.925237284773, 48.0129284508873],
        [106.925192525515, 48.0129610234325],
        [106.925164438788, 48.0129849921637],
        [106.925145184303, 48.0130051171924],
        [106.925121304605, 48.0130343298705],
        [106.92507155321, 48.013107246902],
        [106.925030127738, 48.0131704755371],
        [106.925005508797, 48.0132122886163],
        [106.924977275481, 48.0132695340618],
        [106.924952448797, 48.0133305251836],
        [106.924925667885, 48.0134164679957],
        [106.924913056692, 48.0134803810148],
        [106.924890396475, 48.0135427858709],
        [106.924876973194, 48.0135849209074],
        [106.924873352523, 48.0136218605605],
        [106.924875257287, 48.0136420602329],
        [106.924879655872, 48.0136569593013],
        [106.924888528583, 48.0136724726066],
        [106.924900754866, 48.013686779921],
        [106.924939204481, 48.0137129564878],
        [106.924970289547, 48.0137426107329],
        [106.925001561673, 48.013777291289],
        [106.925033395875, 48.0138270480799],
        [106.925073405813, 48.0138951087723],
        [106.925127460464, 48.0140048431491],
        [106.925199679622, 48.0141327114555],
        [106.925248493024, 48.0142358277213],
        [106.925306604516, 48.0143874030563],
        [106.925326016383, 48.0144390448261],
        [106.925334318924, 48.0144606987024],
        [106.925355104954, 48.0144821430365],
        [106.92538088492, 48.0145035037337],
        [106.925412220897, 48.0145398579281],
        [106.925443992147, 48.0145879401813],
        [106.92549474089, 48.0146759361456],
        [106.925530071656, 48.0147524567605],
        [106.925549108505, 48.0147940468079],
        [106.925552896449, 48.0148152959892],
        [106.925553290352, 48.01483923864],
        [106.925550581594, 48.0148627747973],
        [106.925544925758, 48.0148829645772],
        [106.925523826763, 48.0149201983086],
        [106.92548087784, 48.0149745614269],
        [106.925435650035, 48.0150239764754],
        [106.925391799992, 48.015064902823],
        [106.925354134586, 48.0150947477245],
        [106.925304279769, 48.0151300730944],
        [106.925245345396, 48.0151684408709],
        [106.925187048643, 48.0152024442374],
        [106.925137656977, 48.0152276171609],
        [106.92504222362, 48.0152719267581],
        [106.924877466922, 48.0153505598805],
        [106.924779417436, 48.015393677876],
        [106.924698312977, 48.0154260049063],
        [106.924624230424, 48.0154532750487],
        [106.924545265452, 48.0154797438951],
        [106.924500880311, 48.0154955746611],
        [106.924456247858, 48.0155047045785],
        [106.92440643351, 48.015508891822],
        [106.924346381281, 48.0155065454907],
        [106.924171096219, 48.0154960719862],
        [106.923988195699, 48.0154823726135],
        [106.923918093545, 48.0154785190185],
        [106.923873211979, 48.0154809462887],
        [106.923830950138, 48.0154866839633],
        [106.923805772718, 48.0154940206326],
        [106.923771770251, 48.0155077910518],
        [106.923708034398, 48.0155407098359],
        [106.923614959963, 48.0155908830129],
        [106.923571190858, 48.0156172790143],
        [106.923541733564, 48.0156373716674],
        [106.923486048442, 48.0156852425799],
        [106.923428178867, 48.0157415329455],
        [106.923384729921, 48.0157824916687],
        [106.923358134271, 48.0158064082392],
        [106.923339515606, 48.0158167729258],
        [106.923313938887, 48.0158272626181],
        [106.923249578006, 48.0158434279319],
        [106.923195205894, 48.0158594268711],
        [106.923166016598, 48.0158712079899],
        [106.923128846719, 48.0158890361502],
        [106.923050563433, 48.0159339330046],
        [106.922972219892, 48.0159771535229],
        [106.922921981964, 48.0160008605513],
        [106.922873897912, 48.0160207085889],
        [106.922819319856, 48.0160390448661],
        [106.922720704697, 48.0160668599976],
        [106.922522815176, 48.0161204631889],
        [106.922421311394, 48.0161456316156],
        [106.922349708272, 48.0161686227838],
        [106.922295647326, 48.0161929980085],
        [106.92223946398, 48.0162274645259],
        [106.922175848637, 48.0162637332847],
        [106.92213538454, 48.0162840138962],
        [106.922102185168, 48.0162984929811],
        [106.922040507863, 48.0163196414384],
        [106.921969029747, 48.0163459834804],
        [106.921880134461, 48.0163742941384],
        [106.921825947609, 48.0163953166906],
        [106.9217694504, 48.0164214078218],
        [106.921695910138, 48.0164595174928],
        [106.921654085368, 48.0164769814276],
        [106.921619438986, 48.0164859440711],
        [106.921589598581, 48.0164897958674],
        [106.921562256493, 48.0164936062949],
        [106.9215400945, 48.0165023575978],
        [106.921525485913, 48.0165126611304],
        [106.921506070449, 48.0165280728124],
        [106.921494441315, 48.0165431868187],
        [106.921480223933, 48.0165720910292],
        [106.921454873843, 48.0166295118425],
        [106.921427585715, 48.0167020520581],
        [106.921409541717, 48.0167543206554],
        [106.921396685908, 48.0167928206322],
        [106.921391806187, 48.0168149664376],
        [106.921389813289, 48.016838863223],
        [106.921390927549, 48.0168585664697],
        [106.921402349839, 48.0168969324475],
        [106.921415892729, 48.0169252035354],
        [106.921434305449, 48.0169500410116],
        [106.921473939471, 48.0170080508809],
        [106.921517645623, 48.0170874322392],
        [106.921543096437, 48.0171208870194],
        [106.921565528227, 48.0171421065231],
        [106.92159216075, 48.017163650682],
        [106.921638290575, 48.0171947294532],
        [106.921694601625, 48.0172265007025],
        [106.921755457848, 48.0172547951727],
        [106.921798974243, 48.0172798349964],
        [106.921840221649, 48.0173082184995],
        [106.921878363696, 48.0173393737132],
        [106.921912474981, 48.0173725461062],
        [106.921935883434, 48.0174001166221],
        [106.921957725269, 48.0174312682385],
        [106.921978335931, 48.0174664407237],
        [106.921998768528, 48.0175074327219],
        [106.922013087534, 48.0175430647607],
        [106.922024926209, 48.0175832212887],
        [106.922046474865, 48.0176974972418],
        [106.922062634783, 48.0178023842727],
        [106.922069181847, 48.0178794318903],
        [106.922067807683, 48.0179485339977],
        [106.922058126481, 48.0180108615121],
        [106.922038038325, 48.0180789572781],
        [106.922009695291, 48.0181464675854],
        [106.921866024098, 48.0181929598373],
        [106.92168671547, 48.0182614288219],
        [106.921565695501, 48.0183467762827],
        [106.921483573908, 48.0184046899246],
        [106.921418299315, 48.0184385161247],
        [106.921310354589, 48.0185176933369],
        [106.921195877188, 48.0185404389901],
        [106.921077741345, 48.0185840767938],
        [106.920932344352, 48.0186103145144],
        [106.920803463409, 48.0186035435188],
        [106.920705935531, 48.0185847836609],
        [106.920636137348, 48.0185170674088],
        [106.920554138063, 48.0184589226412],
        [106.920370751909, 48.0182983208109],
        [106.920137378737, 48.0182248515957],
        [106.920001069394, 48.0182568890443],
        [106.919843479393, 48.0183130876789],
        [106.919649985758, 48.0183579836341],
        [106.919391452254, 48.0183236196394],
        [106.919202391377, 48.0183684409508],
        [106.919071397027, 48.0184241944211],
        [106.918945259916, 48.018610801947],
        [106.918870217786, 48.0187400147399],
        [106.918817007599, 48.0188599366368],
        [106.918772662928, 48.0189797092462],
        [106.918768102466, 48.0190958414],
        [106.918811640445, 48.0191933153193],
        [106.918871916606, 48.0192637277389],
        [106.91900611524, 48.0192942192528],
        [106.91913001304, 48.0192861973002],
        [106.919249036514, 48.0192663537593],
        [106.919411503538, 48.0192219767129],
        [106.919574634262, 48.0191954440146],
        [106.919729892321, 48.0191958244278],
        [106.919820094322, 48.0192359773585],
        [106.919871505865, 48.0193065372669],
        [106.9198918881, 48.0193776160842],
        [106.919903404818, 48.0194488423902],
        [106.919924671087, 48.0195437127722],
        [106.919975862296, 48.0196083245646],
        [106.920053761572, 48.0196754661499],
        [106.920091654506, 48.0197403000748],
        [106.920036899284, 48.0198185860589],
        [106.920012622085, 48.0198814837435],
        [106.919980252787, 48.019965347323],
        [106.919889813364, 48.0200382787436],
        [106.919829410399, 48.0200839256327],
        [106.919742740935, 48.0201389389609],
        [106.91969109287, 48.0201814634038],
        [106.919586912706, 48.020242720725],
        [106.919500463576, 48.0203036821692],
        [106.919391518804, 48.0203560910608],
        [106.919190874659, 48.0203587800337],
        [106.919037002456, 48.0203140216748],
        [106.918857815236, 48.0202646623843],
        [106.918701663251, 48.0202625121053],
        [106.918497648448, 48.0203087552449],
        [106.918358677111, 48.0203872264894],
        [106.918233354786, 48.0204511916692],
        [106.917959675798, 48.0205319130174],
        [106.917821762065, 48.0206389224484],
        [106.917798873419, 48.0207868456364],
        [106.917831821881, 48.0209100392669],
        [106.917821348377, 48.0210101607904],
        [106.917769041108, 48.0211300188354],
        [106.917700965128, 48.0212073056726],
        [106.91757581727, 48.0212760264675],
        [106.917485589189, 48.0213298859655],
        [106.917367177253, 48.0213889759206],
        [106.917334727016, 48.0214704266189],
        [106.917345346211, 48.0215654372951],
        [106.917453283742, 48.0216064697628],
        [106.917589581394, 48.0216470282878],
        [106.917635474697, 48.0217366897964],
        [106.917647152394, 48.0218602386591],
        [106.917688603047, 48.0220213656935],
        [106.917615906349, 48.0221653606429],
        [106.917484315749, 48.0223234272844],
        [106.917395232504, 48.0224082036757],
        [106.917325109666, 48.0225259788909],
        [106.917344142918, 48.0226565442642],
        [106.917468997596, 48.0227710648328],
        [106.917585600995, 48.022949974162],
        [106.917628551716, 48.023151530219],
        [106.917651478133, 48.0233457514054],
        [106.917654418916, 48.0233706644247],
        [106.917706605675, 48.0235725415396],
        [106.917732937825, 48.0238057276522],
        [106.917720345518, 48.0238501829397],
        [106.917641630557, 48.024074971183],
        [106.917600482976, 48.0241812467672],
        [106.917557921661, 48.0242840257872],
        [106.917499853336, 48.0244236077634],
        [106.917479636576, 48.0244649352086],
        [106.917458866733, 48.0245012444369],
        [106.917425956942, 48.0245494256155],
        [106.917384679859, 48.0246013102023],
        [106.917336020241, 48.0246563289265],
        [106.917253651335, 48.0247441881938],
        [106.917195386958, 48.0248021512983],
        [106.917108914445, 48.0248281605912],
        [106.916989657147, 48.0248420551168],
        [106.916701383062, 48.0248438906331],
        [106.91650552511, 48.0249453602402],
        [106.916380709102, 48.0250486203976],
        [106.916340125397, 48.0251504749145],
        [106.916348528662, 48.0252574636611],
        [106.916387524165, 48.0253520381661],
        [106.916412557693, 48.0254289913549],
        [106.916424784876, 48.0255005252291],
        [106.916395684613, 48.0255560574661],
        [106.916376435524, 48.0256016575905],
        [106.916364598647, 48.0256431334239],
        [106.916360074158, 48.0256812421956],
        [106.916360958192, 48.0257113398065],
        [106.916365051906, 48.0257418025422],
        [106.916372244683, 48.0257718201134],
        [106.916382354862, 48.0258006289959],
        [106.916402150739, 48.0258381280273],
        [106.916431784299, 48.0258778771624],
        [106.916471222269, 48.0259203782229],
        [106.916531745744, 48.0259777729559],
        [106.916569481297, 48.0260096512244],
        [106.91661574602, 48.0260430700317],
        [106.9168101084, 48.0261008388826],
        [106.917608468956, 48.0259774060325],
        [106.917940090363, 48.0259480620535],
        [106.918147447047, 48.0260368485218],
        [106.918249962566, 48.0261057824559],
        [106.918311432127, 48.0261496765664],
        [106.918455431573, 48.0262072763448],
        [106.918565034649, 48.0262917433693],
        [106.918554494594, 48.0263663151534],
        [106.918499840995, 48.0264475742962],
        [106.918419359766, 48.0265500961101],
        [106.918349621838, 48.0267030267233],
        [106.918306484057, 48.0268555130716],
        [106.91831987766, 48.0269772965651],
        [106.918338035872, 48.0271079284881],
        [106.91838612442, 48.027208302721],
        [106.918380458691, 48.0272946951941],
        [106.918271718965, 48.0273530522016],
        [106.918106668188, 48.0274480583812],
        [106.91800878148, 48.0275597973468],
        [106.917973073898, 48.0276734743514],
        [106.917943566243, 48.027834660741],
        [106.917939003982, 48.0279507928948],
        [106.917955616259, 48.0280397889052],
        [106.91800392604, 48.0281461112541],
        [106.918122730979, 48.0282393520645],
        [106.918199868529, 48.0282856770424],
        [106.918295733561, 48.0283584708668],
        [106.918484593889, 48.028426734806],
        [106.918628124788, 48.0284689741639],
        [106.918824639246, 48.0285043759762],
        [106.918923614134, 48.0285414082594],
        [106.919095624763, 48.0286337596403],
        [106.919168109221, 48.0286742093473],
        [106.91919594144, 48.0287197393246],
        [106.919324595754, 48.0288263359667],
        [106.919372135716, 48.0289118390102],
        [106.919398059573, 48.0290125828645],
        [106.919383197377, 48.029090202451],
        [106.919312022332, 48.0292044721087],
        [106.91922666318, 48.0292951723344],
        [106.919167464407, 48.0293735320629],
        [106.919064921909, 48.0294793984555],
        [106.918866731115, 48.0295184200391],
        [106.918651579107, 48.0295785550064],
        [106.918485146972, 48.0295905699489],
        [106.918396743615, 48.0296453035879],
        [106.918286784408, 48.0296709468568],
        [106.918190457124, 48.0297052892677],
        [106.917998134406, 48.0297828962637],
        [106.917834400237, 48.02991359024],
        [106.917747583284, 48.030084660179],
        [106.917779262803, 48.0302210180856],
        [106.917899839406, 48.0303618420255],
        [106.91811118908, 48.0305576909847],
        [106.918405752124, 48.030598934793],
        [106.918935633573, 48.0306569986216],
        [106.919170388103, 48.0307661565329],
        [106.919253620358, 48.0308570150393],
        [106.919306810761, 48.0309751580771],
        [106.919285842168, 48.031127274804],
        [106.919279278916, 48.0313089072803],
        [106.919194469249, 48.031414477796],
        [106.919006796027, 48.0314979600628],
        [106.918768472087, 48.0315316999281],
        [106.91856796464, 48.0315518672249],
        [106.918423735867, 48.0315672168536],
        [106.918141072652, 48.0316016968609],
        [106.917908395556, 48.0316680740224],
        [106.917787889999, 48.031768288176],
        [106.917746862927, 48.0318582464609],
        [106.91775959463, 48.0319621874051],
        [106.917855135007, 48.0320260590554],
        [106.917990690718, 48.0320922383661],
        [106.918161056488, 48.032139981575],
        [106.918313244261, 48.032176125328],
        [106.918393717396, 48.0321926359814],
        [106.918528722722, 48.0322439450021],
        [106.91873965691, 48.0323088643627],
        [106.918822560013, 48.0323908015943],
        [106.918967743866, 48.0325966815917],
        [106.919074474507, 48.032722857374],
        [106.91919351327, 48.0328220454011],
        [106.919205364536, 48.0329021938812],
        [106.919168772921, 48.032992079321],
        [106.919104140444, 48.0330437480706],
        [106.919065671044, 48.0330830754236],
        [106.918922442317, 48.0331687916065],
        [106.918750068361, 48.033186550519],
        [106.918607186772, 48.0331621555091],
        [106.918387404155, 48.0331022669561],
        [106.918248381558, 48.0330580445931],
        [106.918163694199, 48.0330475558001],
        [106.918065152785, 48.0330224188496],
        [106.917935794302, 48.0330037489239],
        [106.917758545121, 48.0330096844494],
        [106.917661328408, 48.0330202352957],
        [106.917513221758, 48.0330941271923],
        [106.917423309338, 48.033181926205],
        [106.917329292413, 48.0332787211361],
        [106.917198570558, 48.0334624274491],
        [106.917118296172, 48.0335708955804],
        [106.916957527068, 48.0337818855256],
        [106.916907518467, 48.0338690181407],
        [106.916901298756, 48.033940541223],
        [106.916935096178, 48.0340143719657],
        [106.916999159384, 48.0340668662929],
        [106.917042597538, 48.0341613670535],
        [106.916871985354, 48.0342267063974],
        [106.916659810102, 48.0342481021682],
        [106.916460496954, 48.0342573795745],
        [106.916285008646, 48.0343108964308],
        [106.916184104713, 48.0344613700962],
        [106.916045743117, 48.03455890427],
        [106.915900078126, 48.0345791884788],
        [106.915721500647, 48.0345494335096],
        [106.915468424228, 48.0345447273573],
        [106.915316206778, 48.0346276124744],
        [106.915291917888, 48.0346905092596],
        [106.915364052509, 48.0348410719579],
        [106.915357783335, 48.0351506590757],
        [106.915277785941, 48.0355061125171],
        [106.915065642166, 48.0358875761508],
        [106.915003720246, 48.0360142384664],
        [106.914676692575, 48.0361402721559],
        [106.914568416, 48.0361817246069],
        [106.914322077302, 48.0362722674512],
        [106.914214232401, 48.0363141506776],
        [106.914091594552, 48.0363668014867],
        [106.913986984512, 48.0364186977648],
        [106.91390721015, 48.0364625568016],
        [106.913840487648, 48.0365014767618],
        [106.913781524498, 48.0365385450179],
        [106.91372909672, 48.0365745637652],
        [106.913639044906, 48.0366440354939],
        [106.913560990947, 48.0367137770192],
        [106.913507546037, 48.0367679818569],
        [106.913462670766, 48.03681867754],
        [106.913425303935, 48.036867066462],
        [106.913395126284, 48.0369135811969],
        [106.913380276678, 48.0369417119905],
        [106.91336744695, 48.0369717637359],
        [106.913347226593, 48.0370392029969],
        [106.913335446374, 48.0371020710038],
        [106.913185427765, 48.0372342128887],
        [106.913147390939, 48.0372854355745],
        [106.91306977495, 48.0373462441339],
        [106.913014221129, 48.037403709014],
        [106.912950128246, 48.0374702444562],
        [106.912877716633, 48.0375517967781],
        [106.912800540413, 48.0376245015696],
        [106.912736997914, 48.0377059055032],
        [106.912637759525, 48.0377819530747],
        [106.912574326744, 48.0378663319657],
        [106.912524196734, 48.0379504887241],
        [106.912452445224, 48.0380498844946],
        [106.912376478592, 48.0381553021256],
        [106.912317589185, 48.0382425813301],
        [106.912169209142, 48.0384295503835],
        [106.912087134314, 48.0385168925406],
        [106.912005621562, 48.0385619377832],
        [106.911936016734, 48.0386051385164],
        [106.911873053399, 48.0386497385946],
        [106.911807121402, 48.0387021321977],
        [106.911743160718, 48.0387573541686],
        [106.911614463237, 48.0388732102305],
        [106.911456066544, 48.0390198150125],
        [106.911228882507, 48.0392433927684],
        [106.911102227386, 48.0393657248484],
        [106.911040042864, 48.0394334698788],
        [106.910971708777, 48.0395226934176],
        [106.910943231745, 48.0395654822612],
        [106.910918399664, 48.0396072728574],
        [106.910886571758, 48.0396705014925],
        [106.910855682744, 48.0397447279369],
        [106.910838219708, 48.0397951879976],
        [106.910822468982, 48.0398511824861],
        [106.910883653458, 48.0400221651908],
        [106.910957083103, 48.0400878984378],
        [106.911228804266, 48.040121107703],
        [106.911379330991, 48.0401614369009],
        [106.911545118313, 48.0403264454092],
        [106.911522745878, 48.0404410424202],
        [106.911376310169, 48.0405113001564],
        [106.911130504769, 48.0405775064468],
        [106.910841338557, 48.0406775425346],
        [106.910673533157, 48.0407942772342],
        [106.910554615803, 48.0408890630799],
        [106.91044673313, 48.0409943736914],
        [106.91035814811, 48.0410458203084],
        [106.910316564358, 48.0410960366528],
        [106.91025624413, 48.0411688790406],
        [106.910168582714, 48.0412452971328],
        [106.910071337223, 48.0413504305779],
        [106.909977300512, 48.041398397718],
        [106.90982408931, 48.0414295016702],
        [106.909685253771, 48.0414175325931],
        [106.909576356664, 48.0413515223549],
        [106.909461085161, 48.0412570620638],
        [106.909363017689, 48.0411395701351],
        [106.909267909886, 48.0410875866229],
        [106.909156383161, 48.041071585885],
        [106.909028106562, 48.0410826457476],
        [106.908877656279, 48.0410940734328],
        [106.908683188678, 48.0411151607361],
        [106.908546702169, 48.0411442106368],
        [106.908397349958, 48.0411853780029],
        [106.908230699287, 48.0412387347798],
        [106.908099195921, 48.0412825812262],
        [106.907943610509, 48.0413952698759],
        [106.907876059732, 48.0414886419873],
        [106.907812944412, 48.041581939455],
        [106.907762802711, 48.0416660944148],
        [106.907739600202, 48.0417587290821],
        [106.907774707936, 48.0418682503196],
        [106.90784596482, 48.0419716444759],
        [106.907856531853, 48.0420210802087],
        [106.907924859645, 48.0420889403524],
        [106.907983170787, 48.0421058269224],
        [106.908159903757, 48.042085035496],
        [106.908519780963, 48.0420969110436],
        [106.908641607624, 48.0421514261474],
        [106.90871575223, 48.0422364921205],
        [106.908665282277, 48.0423117258056],
        [106.908606930665, 48.0424138717029],
        [106.908572622429, 48.0425662078642],
        [106.908528345207, 48.0426889509344],
        [106.908468894624, 48.0427613571509],
        [106.908337717712, 48.0428141257713],
        [106.908202983981, 48.0428907588015],
        [106.908032331327, 48.042956085555],
        [106.907967376893, 48.0429954138074],
        [106.907914839398, 48.0430237667335],
        [106.907900836954, 48.0430353266191],
        [106.907883219235, 48.043046437743],
        [106.907861983544, 48.0430571001052],
        [106.907808809329, 48.0430770461688],
        [106.907739971622, 48.043095672927],
        [106.907694426357, 48.0431041049705],
        [106.90764346987, 48.0431092365021],
        [106.907587921445, 48.0431109784889],
        [106.907529518572, 48.043109272475],
        [106.907480540595, 48.043104301922],
        [106.907427030933, 48.0430947331355],
        [106.907368470678, 48.0430806794299],
        [106.907286521756, 48.0430577332278],
        [106.907237803682, 48.0430420688365],
        [106.907185440656, 48.0430218790565],
        [106.907019391632, 48.0429473270576],
        [106.906957530865, 48.0429217305535],
        [106.906745276473, 48.0428468458053],
        [106.906675025032, 48.0428203238989],
        [106.906642891356, 48.0428058349214],
        [106.906546271793, 48.042756811078],
        [106.906513928575, 48.0427447655585],
        [106.906483619623, 48.0427376114517],
        [106.906456501466, 48.0427342129137],
        [106.906427329258, 48.0427324925106],
        [106.906364903717, 48.0427341787394],
        [106.906301419675, 48.0427425397365],
        [106.906243235337, 48.0427567589173],
        [106.906208088932, 48.0427693044599],
        [106.906174219565, 48.0427845021031],
        [106.906143541891, 48.0428014875986],
        [106.906117470545, 48.0428194740396],
        [106.906099068617, 48.0428368777198],
        [106.906083115543, 48.0428586395146],
        [106.906046203769, 48.0429334532163],
        [106.906032146466, 48.0429573014384],
        [106.906016441606, 48.0430513651285],
        [106.90603747405, 48.0431320469065],
        [106.906107070785, 48.0432142134652],
        [106.906158927493, 48.0432966750016],
        [106.906170651055, 48.0433738512223],
        [106.906181935748, 48.043439131211],
        [106.906157960721, 48.0435109474723],
        [106.906173789689, 48.0435791286739],
        [106.906153371481, 48.0436270796261],
        [106.906119977855, 48.0436841739855],
        [106.906043880821, 48.0437866139611],
        [106.906010157143, 48.0438347861465],
        [106.905882047818, 48.0439708220958],
        [106.905775015005, 48.0440767505416],
        [106.9056446241, 48.0441926875425],
        [106.905160106254, 48.0443696525375],
        [106.90478828695, 48.0445156817533],
        [106.904691404785, 48.044560724298],
        [106.90468021542, 48.0446108354218],
        [106.904671877805, 48.0446640599984],
        [106.90466622017, 48.0447214772145],
        [106.904662283837, 48.0448268975433],
        [106.904663151683, 48.0450591096902],
        [106.904658881702, 48.0451539207169],
        [106.904649687033, 48.0453788969186],
        [106.90464250145, 48.045438457219],
        [106.904631136718, 48.0454912006584],
        [106.904599829519, 48.0455946685592],
        [106.904566685904, 48.0456772416115],
        [106.9045479872, 48.0457143206594],
        [106.904527753353, 48.0457487098352],
        [106.904505845868, 48.0457806510562],
        [106.904482166719, 48.0458102810197],
        [106.904438392218, 48.0458552372295],
        [106.904382634251, 48.0459022861616],
        [106.904315430613, 48.045951580701],
        [106.904208744938, 48.0460236415778],
        [106.904128823986, 48.0460731780348],
        [106.904034034543, 48.0461243296741],
        [106.903940169603, 48.0461702868293],
        [106.903715033322, 48.0462756055348],
        [106.903607225293, 48.0463300136193],
        [106.903452005006, 48.0464161686713],
        [106.903192188169, 48.04672339327],
        [106.903156984207, 48.0468519351687],
        [106.90314423362, 48.0471080638861],
        [106.903128743697, 48.0472898438513],
        [106.903115057814, 48.0474001744785],
        [106.902978441802, 48.047426244026],
        [106.902822549721, 48.0474109726383],
        [106.902666548822, 48.0473927262933],
        [106.902511423863, 48.0473982715131],
        [106.902349510821, 48.0474604695251],
        [106.902240202723, 48.0475307749254],
        [106.902236010983, 48.0476031910345],
        [106.902236008285, 48.0476551619562],
        [106.902239050692, 48.0477106816027],
        [106.90225473217, 48.0478386542306],
        [106.902264723638, 48.0478894965031],
        [106.902279694652, 48.0479453228185],
        [106.902395681116, 48.04811140152],
        [106.902405866837, 48.0481469427273],
        [106.902440309972, 48.0482386214153],
        [106.902435493203, 48.0483488054531],
        [106.90244877619, 48.048427266805],
        [106.902454202699, 48.0485180048021],
        [106.902489817651, 48.0486187018917],
        [106.902511065933, 48.0487135749716],
        [106.902623322009, 48.0488694319787],
        [106.902710881802, 48.0489572552731],
        [106.902818046815, 48.0490953416767],
        [106.902882392409, 48.0492757987392],
        [106.902881354591, 48.0493680646845],
        [106.902856334552, 48.0495321477904],
        [106.902741399396, 48.0496649866499],
        [106.902565024356, 48.0498166977824],
        [106.902453208949, 48.0499137751007],
        [106.902192886692, 48.0500758032558],
        [106.902149120286, 48.0501556765433],
        [106.902177003766, 48.0503214395828],
        [106.902194526157, 48.0504029919046],
        [106.902215765445, 48.0504877593027],
        [106.902270227489, 48.0506701876791],
        [106.902314119801, 48.0507940198282],
        [106.902381550968, 48.0509647444275],
        [106.90245604631, 48.0511236591296],
        [106.902470959767, 48.0511631258776],
        [106.902480600499, 48.0511988775262],
        [106.902492318666, 48.0512632258172],
        [106.902497134535, 48.0513143199],
        [106.902495766666, 48.0513599074338],
        [106.902488043289, 48.0514008454727],
        [106.90247805272, 48.0514299736145],
        [106.902463955847, 48.051460866226],
        [106.902445617771, 48.0514938371709],
        [106.902422468322, 48.051529922468],
        [106.902387826437, 48.0515746970147],
        [106.902343064481, 48.0516215678811],
        [106.902287572713, 48.0516714829527],
        [106.902209006141, 48.0517355497558],
        [106.902152097941, 48.0517771874673],
        [106.902083541722, 48.0518205168035],
        [106.902014798444, 48.0518597910965],
        [106.901847440007, 48.0519510345127],
        [106.901766580164, 48.0519988586604],
        [106.901603434151, 48.0521043689216],
        [106.901430747231, 48.0522218239781],
        [106.901243957143, 48.0523541960893],
        [106.901012251314, 48.0525233118014],
        [106.900819520305, 48.0526593072813],
        [106.900769462241, 48.0526992542672],
        [106.900728737341, 48.0527368306403],
        [106.900673606202, 48.0527979728482],
        [106.900622267504, 48.0528666073081],
        [106.900574280579, 48.052943292499],
        [106.90052852667, 48.0530298081791],
        [106.900503907729, 48.053086554501],
        [106.900481983157, 48.0531508785103],
        [106.900463732315, 48.0532169094329],
        [106.90042996637, 48.0533547844958],
        [106.900408260333, 48.0534540714483],
        [106.900369059784, 48.0536794892171],
        [106.900345163898, 48.0537805802097],
        [106.900312123706, 48.0539079637816],
        [106.90029832181, 48.0539448908441],
        [106.90028205847, 48.0539769786547],
        [106.900257388268, 48.0540144641962],
        [106.900226733977, 48.0540530945747],
        [106.90019005153, 48.0540929291454],
        [106.900147176351, 48.0541341477727],
        [106.900105560223, 48.0541680171403],
        [106.900053720603, 48.0542028460845],
        [106.900000908815, 48.0542340039962],
        [106.899872947878, 48.0543051169876],
        [106.899813196022, 48.0543417625623],
        [106.899738420991, 48.0543926111301],
        [106.899657317431, 48.0544506551736],
        [106.899394156915, 48.0546481669793],
        [106.899294612756, 48.0547208402946],
        [106.899260157031, 48.0547435086061],
        [106.899169014339, 48.0547971144953],
        [106.899129859655, 48.0548224591892],
        [106.899094029766, 48.0548512347967],
        [106.899069349671, 48.0548795022872],
        [106.899050396459, 48.0549139571135],
        [106.899036932708, 48.0549542098689],
        [106.899028796542, 48.0550005888062],
        [106.899025578768, 48.0550553719079],
        [106.899027674188, 48.0550904328773],
        [106.89903507381, 48.0551294715479],
        [106.899072928973, 48.0552499429306],
        [106.899094650298, 48.0553113468412],
        [106.899150650182, 48.055450748953],
        [106.899190211359, 48.0555510584347],
        [106.899206556537, 48.0556047614506],
        [106.899216172988, 48.055652135038],
        [106.89922200689, 48.0556953249793],
        [106.899224208431, 48.0557354509303],
        [106.8992227893, 48.0557729031969],
        [106.899212215971, 48.0558353683077],
        [106.899191521671, 48.0559000421533],
        [106.899161088613, 48.0559657016559],
        [106.899121740576, 48.0560305562652],
        [106.899098563248, 48.0560606979429],
        [106.899068559167, 48.056092876585],
        [106.898951018675, 48.0561998365533],
        [106.898908493332, 48.0562429086833],
        [106.898836574548, 48.0563212117546],
        [106.898803709723, 48.0563596128059],
        [106.898775288449, 48.0563982935465],
        [106.898754756927, 48.0564340685775],
        [106.898734579737, 48.0564850340571],
        [106.898720951411, 48.0565413244227],
        [106.898713844968, 48.0566030278076],
        [106.898713212745, 48.0566705291217],
        [106.898718324491, 48.0567245154241],
        [106.898729804337, 48.0567814901737],
        [106.898747683759, 48.0568416179464],
        [106.898772088661, 48.0569053286181],
        [106.898807743183, 48.0569758381645],
        [106.89880770721, 48.0571070510496],
        [106.898487857029, 48.0573414737301],
        [106.898349510721, 48.0574419603782],
        [106.898291341672, 48.0575500498949],
        [106.898276987593, 48.0576425370735],
        [106.898359353801, 48.0577096184042],
        [106.898500374693, 48.0578025120763],
        [106.89857561917, 48.0579173240253],
        [106.898624356129, 48.0580355498008],
        [106.898636619285, 48.0581275963116],
        [106.898670626248, 48.0582073805662],
        [106.898642307497, 48.0582822428313],
        [106.898564752661, 48.0583460164556],
        [106.898481996147, 48.0583890445188],
        [106.898356955309, 48.0584893126317],
        [106.898209404441, 48.0585810245947],
        [106.898151233593, 48.0586891141114],
        [106.898142299727, 48.0588082922689],
        [106.898137035995, 48.0589065800747],
        [106.898205267559, 48.0590720966999],
        [106.898258051468, 48.0593003590244],
        [106.898402139947, 48.059476524522],
        [106.898392549577, 48.0595778592309],
        [106.898375399505, 48.0597150292253],
        [106.89838010206, 48.0598429092229],
        [106.898365528546, 48.0599294482855],
        [106.89831666748, 48.0600492865454],
        [106.898036085297, 48.0602719442949],
        [106.897511310199, 48.0603601722842],
        [106.89727557181, 48.0604682186334],
        [106.897170673987, 48.0606336192462],
        [106.896915135225, 48.0610484971904],
        [106.896896669446, 48.0611499784887],
        [106.896952529935, 48.0612204745453],
        [106.897167056015, 48.0613805997349],
        [106.897562713648, 48.0615169009843],
        [106.897849820413, 48.0615984551047],
        [106.898233555734, 48.0616961205795],
        [106.898289299312, 48.0617191513178],
        [106.898370906492, 48.0617654151418],
        [106.898406775053, 48.061895756584],
        [106.898369677119, 48.06221477759],
        [106.898302569708, 48.0624420461635],
        [106.898223196443, 48.0625772673271],
        [106.898079894871, 48.06270732908],
        [106.898072323479, 48.0627341396689],
        [106.898062835631, 48.0627574842705],
        [106.898039122308, 48.0627972271104],
        [106.898004912996, 48.062839379234],
        [106.897960753586, 48.0628840278756],
        [106.897888989485, 48.0629489742158],
        [106.897852143362, 48.0629799459678],
        [106.897810858185, 48.0630107999086],
        [106.897764709474, 48.0630418570961],
        [106.897712803303, 48.0630737209755],
        [106.897614872528, 48.0631282585624],
        [106.897347992416, 48.0632677847805],
        [106.897268039988, 48.063310450417],
        [106.897176723727, 48.0633560127698],
        [106.89694536054, 48.06332030249],
        [106.896730150976, 48.0633833719451],
        [106.896662115464, 48.0634648415292],
        [106.896580878805, 48.063549504606],
        [106.896502439936, 48.0635894848669],
        [106.896400505379, 48.0635941433551],
        [106.896301369513, 48.0635541190274],
        [106.896085459377, 48.0634773376091],
        [106.895865222602, 48.0634036021945],
        [106.895629424858, 48.0633896393204],
        [106.895511055191, 48.0634302778851],
        [106.895349956935, 48.0635162584686],
        [106.895316975198, 48.0635852454628],
        [106.895381491663, 48.0636496477131],
        [106.89547728295, 48.0637194863652],
        [106.895515943906, 48.0638051458908],
        [106.895510457142, 48.0638974855805],
        [106.895445435259, 48.0639402186662],
        [106.895290915543, 48.0639635992408],
        [106.895144395298, 48.0639630407618],
        [106.894970490696, 48.0639421036452],
        [106.894869538199, 48.0639735268568],
        [106.894722620453, 48.0640830786712],
        [106.89459054152, 48.0642340460644],
        [106.894516138809, 48.0643840619749],
        [106.894449409113, 48.0645012184565],
        [106.894435700747, 48.0646115481845],
        [106.894462906138, 48.0647479852314],
        [106.894542371134, 48.0648567780179],
        [106.894626054849, 48.0649595498434],
        [106.894741232822, 48.0650737052873],
        [106.894797203928, 48.0651471763012],
        [106.894810008475, 48.0652540931019],
        [106.894870853907, 48.0653393866034],
        [106.89497941197, 48.065394135531],
        [106.895122919487, 48.0654334287098],
        [106.895399969133, 48.0654824219762],
        [106.895729604837, 48.0655126913577],
        [106.896020336769, 48.0656923902916],
        [106.896141377423, 48.0658451329466],
        [106.896740696426, 48.0676564125135],
        [106.896831056708, 48.0679405946827],
        [106.896848239155, 48.0681664702065],
        [106.8968113022, 48.0683694328031],
        [106.896752681691, 48.0684656251885],
        [106.896680448144, 48.0686177212309],
        [106.896575760763, 48.0687485222266],
        [106.896379802986, 48.0689230941255],
        [106.896201986333, 48.0690116980315],
        [106.896009856969, 48.0690570094734],
        [106.895789836032, 48.0691082339579],
        [106.895712511423, 48.0691779260205],
        [106.895690158774, 48.0692943036892],
        [106.895721358054, 48.069418721297],
        [106.895774079011, 48.0695249357273],
        [106.895844651509, 48.0696338310365],
        [106.895829640026, 48.0697084432901],
        [106.895767477987, 48.0698284524212],
        [106.895655651787, 48.0699254847734],
        [106.895530955389, 48.0700346273962],
        [106.895339108413, 48.0702510357568],
        [106.895207051065, 48.0703837307246],
        [106.895099109936, 48.0705878642386],
        [106.894965199984, 48.0708102809697],
        [106.894899227517, 48.0709482549581],
        [106.894897124003, 48.071132787748],
        [106.895007988828, 48.0712499891957],
        [106.895243973631, 48.0713889335525],
        [106.895581211304, 48.0713833685477],
        [106.895847233463, 48.0713730263441],
        [106.896007632946, 48.0713882338799],
        [106.896121981744, 48.0713971092892],
        [106.896200560008, 48.0714310928707],
        [106.896278143622, 48.0714567604212],
        [106.896432073382, 48.0715076863307],
        [106.896549025717, 48.0715785106398],
        [106.896588417821, 48.0716391294423],
        [106.896627809926, 48.0716997473455],
        [106.896682892502, 48.0717983984774],
        [106.896724041881, 48.0719068531188],
        [106.89676519216, 48.0720153077603],
        [106.896781474386, 48.0721471483723],
        [106.896797756611, 48.0722789889842],
        [106.896836007476, 48.0723705183848],
        [106.896854177378, 48.0724139970084],
        [106.896887556616, 48.072493867598],
        [106.896910599045, 48.0725490050326],
        [106.896914397781, 48.0726523326391],
        [106.89691351105, 48.0727059565147],
        [106.896912624318, 48.0727595812897],
        [106.896852724074, 48.072840984324],
        [106.896780129, 48.0728881339802],
        [106.896724535609, 48.072931174634],
        [106.896648008699, 48.0729420231559],
        [106.89653835706, 48.0729575670382],
        [106.896437614105, 48.0729767019133],
        [106.896304362456, 48.0730108680572],
        [106.89611691946, 48.0730445962312],
        [106.89597547229, 48.073055073333],
        [106.895865987925, 48.0730526190832],
        [106.895762217852, 48.0730389628779],
        [106.895740114315, 48.073029421071],
        [106.895676230973, 48.0730018424611],
        [106.895616975543, 48.0729762621448],
        [106.895545452461, 48.0728970282753],
        [106.895509376157, 48.0728241265323],
        [106.895482408187, 48.0727372385328],
        [106.895473317839, 48.0726454869997],
        [106.895456641711, 48.0726088018547],
        [106.895442218384, 48.0725770728737],
        [106.895427744695, 48.0725678449302],
        [106.895381917042, 48.0725386286548],
        [106.895348541402, 48.0725173506953],
        [106.895311117914, 48.072510309903],
        [106.895273694425, 48.0725032682113],
        [106.895245545645, 48.0725152211006],
        [106.895228431547, 48.0725224876227],
        [106.895208869494, 48.0725370980087],
        [106.895190633041, 48.072558322009],
        [106.89516779206, 48.0725849050694],
        [106.895140634333, 48.0726165135413],
        [106.895127531211, 48.0726474610116],
        [106.895074897489, 48.0727030328188],
        [106.894892586024, 48.0727715260851],
        [106.894781467591, 48.0728004986441],
        [106.894696388128, 48.0728191343956],
        [106.894606506285, 48.072862738025],
        [106.894590702499, 48.0729367783097],
        [106.894659157095, 48.0730330462381],
        [106.894701795751, 48.0730488545211],
        [106.894735510436, 48.0730613541982],
        [106.894819198647, 48.0730773666272],
        [106.894853382777, 48.0730773612313],
        [106.894925671183, 48.0730773486408],
        [106.895016392992, 48.073108028113],
        [106.895058472271, 48.0731577714141],
        [106.895073110536, 48.0732804830079],
        [106.895050785765, 48.0733726949939],
        [106.895008539213, 48.0734614994487],
        [106.894941950711, 48.0735205849071],
        [106.894877896498, 48.0735442523654],
        [106.894761679808, 48.0735618224202],
        [106.89466262488, 48.0735417990149],
        [106.894647209601, 48.073538682864],
        [106.894506996301, 48.0735392557321],
        [106.894428711216, 48.0735996811804],
        [106.894404711009, 48.0736946711722],
        [106.894397311387, 48.073819298322],
        [106.894359890597, 48.0739886658443],
        [106.894367059992, 48.0740424632891],
        [106.894429476539, 48.0741014893923],
        [106.89449600029, 48.07412418918],
        [106.894635479744, 48.0741121148823],
        [106.894823495608, 48.0741016476729],
        [106.894970324321, 48.0740976708709],
        [106.895002756572, 48.0740967922332],
        [106.895135235703, 48.0741267324628],
        [106.895303140028, 48.0741731257892],
        [106.895494982508, 48.0742123164453],
        [106.895564740221, 48.0742024688689],
        [106.895646066813, 48.0741541671811],
        [106.895706378047, 48.0740992563756],
        [106.895809594138, 48.0740105904165],
        [106.895852282257, 48.0739924654799],
        [106.89589909197, 48.0739725895634],
        [106.895919408554, 48.0739703700366],
        [106.895974101723, 48.0739643949409],
        [106.8960319695, 48.073984311327],
        [106.896051540546, 48.0740222510261],
        [106.896063378322, 48.0740706966054],
        [106.896079052606, 48.0741348461463],
        [106.896094697213, 48.0741835750121],
        [106.896123485411, 48.0742732446146],
        [106.896152370735, 48.07436321549],
        [106.89618172101, 48.0744537997031],
        [106.896207007248, 48.0745779780913],
        [106.896383340019, 48.0748182319759],
        [106.896443867091, 48.0749526050787],
        [106.896418331741, 48.0750870950934],
        [106.896361911873, 48.0751976280681],
        [106.896317001528, 48.0752591201124],
        [106.896273167673, 48.0752994511088],
        [106.896205524266, 48.0753423496698],
        [106.896133765561, 48.0753556290591],
        [106.896044948516, 48.0753698491393],
        [106.895883177567, 48.07539805008],
        [106.895783304256, 48.0754003442506],
        [106.895698483798, 48.0754112620202],
        [106.895621667306, 48.0754061340859],
        [106.895547988549, 48.07536484711],
        [106.895475285556, 48.0752731792139],
        [106.895373705332, 48.0752121134483],
        [106.895294918426, 48.075178010257],
        [106.895273662949, 48.0751339326849],
        [106.895253592779, 48.0751037883093],
        [106.895224916097, 48.0750607152798],
        [106.895206283943, 48.074966261284],
        [106.895159586646, 48.0749331905144],
        [106.895088760538, 48.0749309745848],
        [106.895029443954, 48.0749844437771],
        [106.894999427282, 48.0750372915378],
        [106.89497694513, 48.0751019132228],
        [106.894968308041, 48.0751567880554],
        [106.894962957974, 48.0752044692109],
        [106.895009678654, 48.0752798728679],
        [106.895002908557, 48.0753572325503],
        [106.894982593772, 48.0754181859006],
        [106.894894931456, 48.0754792534648],
        [106.89474486968, 48.0755507387756],
        [106.894644489152, 48.075621404804],
        [106.894530909274, 48.0757313721052],
        [106.894512319388, 48.0757741096875],
        [106.894537741424, 48.0758087794517],
        [106.894581200262, 48.0758318596527],
        [106.894621855914, 48.0758552375292],
        [106.894643363201, 48.0758808070536],
        [106.89467669927, 48.0759183321654],
        [106.894686486592, 48.0759326421777],
        [106.894728773614, 48.0759944687697],
        [106.894803683543, 48.0760753286136],
        [106.894874289317, 48.0761256726617],
        [106.894942075716, 48.0761836204778],
        [106.894997655617, 48.0761974070847],
        [106.895086411509, 48.076192811549],
        [106.895172822868, 48.0761326460049],
        [106.895231974876, 48.0760785445892],
        [106.895262549127, 48.0759700332904],
        [106.895307866865, 48.0758709217057],
        [106.89535682146, 48.0758250131139],
        [106.895420437703, 48.0758168247867],
        [106.895496413329, 48.0758292363303],
        [106.895567509233, 48.0758572313262],
        [106.895624001047, 48.0759312815035],
        [106.895672577028, 48.0760026031377],
        [106.895717062892, 48.0760617938168],
        [106.895761617105, 48.0761530516221],
        [106.895740268998, 48.076219823586],
        [106.895678269736, 48.0762623264453],
        [106.895651452852, 48.0763056027214],
        [106.895667657736, 48.0763600674632],
        [106.895726690135, 48.0763900823365],
        [106.895835237406, 48.0763787185031],
        [106.896002380006, 48.0763854787069],
        [106.89609785833, 48.0764503764838],
        [106.896145364117, 48.0766044276523],
        [106.896203588025, 48.0767688057359],
        [106.89625688185, 48.0769333600866],
        [106.89628333271, 48.0770733233752],
        [106.89632438856, 48.0771920707575],
        [106.896325054957, 48.0771939980046],
        [106.896391557125, 48.0772642899151],
        [106.896435542067, 48.0773016378603],
        [106.896449153306, 48.0773033807465],
        [106.896621528161, 48.0773254483108],
        [106.896827314629, 48.0773332445336],
        [106.896913449896, 48.077357998373],
        [106.896971816796, 48.0774419590792],
        [106.896980761453, 48.0775773088458],
        [106.89696934456, 48.0776497915047],
        [106.896923368519, 48.0777243030342],
        [106.896883010543, 48.0778499491159],
        [106.896808869534, 48.0779582580672],
        [106.896729683328, 48.0780862828557],
        [106.896648138201, 48.0781863854933],
        [106.896599233068, 48.0783049862861],
        [106.896512461981, 48.0785527144363],
        [106.896396503396, 48.0788758831156],
        [106.896221538493, 48.0790429681585],
        [106.895999000354, 48.0791910873988],
        [106.895816970377, 48.0792626266689],
        [106.895631331421, 48.0793132827818],
        [106.895475552655, 48.0794034254278],
        [106.895461663525, 48.0794893223744],
        [106.895466277946, 48.079614892913],
        [106.895532936596, 48.0797257289593],
        [106.895689916856, 48.079902472721],
        [106.895695212064, 48.0800175616612],
        [106.895609982415, 48.0801141542449],
        [106.895474540917, 48.0801972974673],
        [106.895207608644, 48.0802778515417],
        [106.895033999919, 48.0803854212502],
        [106.894871387205, 48.080502326821],
        [106.894751012949, 48.0806090178919],
        [106.894682441442, 48.0807185274381],
        [106.894649035225, 48.0808408037601],
        [106.894629325683, 48.0810134915794],
        [106.894601814522, 48.0811153191167],
        [106.894558757681, 48.0812193068256],
        [106.894484170608, 48.0813157231421],
        [106.894324541844, 48.0813882777469],
        [106.894215346161, 48.0814319605166],
        [106.894088694638, 48.0814645087801],
        [106.893920012399, 48.0815129795404],
        [106.893810675522, 48.0815528572786],
        [106.893729250005, 48.0815897618581],
        [106.893701143493, 48.0816236231317],
        [106.893677113608, 48.0816582236482],
        [106.893657860022, 48.081692548972],
        [106.893643769444, 48.0817258976321],
        [106.893634515421, 48.0817654929832],
        [106.893632675408, 48.0818106695268],
        [106.893637237668, 48.0818590017915],
        [106.893651927195, 48.0819480625531],
        [106.89366549077, 48.0820178985073],
        [106.893687753487, 48.0821024077999],
        [106.893719933029, 48.0822004330036],
        [106.893765991807, 48.08231668117],
        [106.893804021438, 48.0823969096897],
        [106.893896615636, 48.0825689221181],
        [106.893928564951, 48.0826373461367],
        [106.893961643815, 48.0827106210983],
        [106.893972956387, 48.0827511310599],
        [106.893975081485, 48.082781002941],
        [106.893973196506, 48.0828126042184],
        [106.893981979285, 48.0829167915767],
        [106.893977583399, 48.0830291843494],
        [106.893968949907, 48.0831035717725],
        [106.89394569254, 48.0831665405035],
        [106.893876135375, 48.083303328286],
        [106.893805793103, 48.0834187122039],
        [106.893704727291, 48.0835388850116],
        [106.893607073508, 48.0836068872481],
        [106.893502572286, 48.0836895448367],
        [106.893481735893, 48.0837188942116],
        [106.89347398014, 48.0837615580495],
        [106.893487054484, 48.0838162017563],
        [106.893515565691, 48.0838589456339],
        [106.89359218703, 48.083965092615],
        [106.893627587943, 48.084023258067],
        [106.893690790498, 48.0841481882883],
        [106.893710694293, 48.0841945951045],
        [106.893725923413, 48.0842371995872],
        [106.893750777976, 48.0843300024277],
        [106.893758219866, 48.0843719629957],
        [106.893762493444, 48.0844117418085],
        [106.893763924266, 48.0844558796352],
        [106.893762153501, 48.084501148809],
        [106.893757190142, 48.0845472588489],
        [106.893749073761, 48.0845938446303],
        [106.893736838484, 48.084640342278],
        [106.893718314249, 48.0846914822262],
        [106.893647697683, 48.0848447599777],
        [106.893594652971, 48.0849511506751],
        [106.893530652718, 48.0850649418936],
        [106.893454184263, 48.0851890555305],
        [106.893354264188, 48.0853413494238],
        [106.89326778538, 48.0854769842754],
        [106.89323062899, 48.085531649566],
        [106.893187667477, 48.0855870576966],
        [106.893143842614, 48.0856344807468],
        [106.89308684718, 48.0856894581021],
        [106.89304309876, 48.0857276657992],
        [106.89300051766, 48.0857596645769],
        [106.892958371831, 48.0857857368223],
        [106.892897345636, 48.0858155520461],
        [106.89282756544, 48.0858425245129],
        [106.892750894638, 48.0858659230739],
        [106.892670446684, 48.0858847890518],
        [106.892630025755, 48.0858916499797],
        [106.892586852901, 48.0858965314998],
        [106.892540508138, 48.0858994875713],
        [106.89249013801, 48.085900573053],
        [106.892393433011, 48.0858983175534],
        [106.892167809297, 48.0858863340871],
        [106.892051884887, 48.0858791008399],
        [106.89177905486, 48.0858532354385],
        [106.891707956257, 48.0858491264361],
        [106.891643595376, 48.0858478134259],
        [106.89151885671, 48.0858459248496],
        [106.89146303669, 48.0858467270449],
        [106.89140870235, 48.0858509871334],
        [106.891362504176, 48.0858591781586],
        [106.891332256379, 48.0858674429282],
        [106.891260666746, 48.0859192222943],
        [106.891108487966, 48.0861082930633],
        [106.891021828395, 48.0863019962402],
        [106.89096527183, 48.0864523772754],
        [106.890985013747, 48.086581379627],
        [106.891011106677, 48.0866192428838],
        [106.891085289055, 48.0866506211293],
        [106.891148781191, 48.0866560953026],
        [106.891207051864, 48.0866518756836],
        [106.891356816864, 48.0866200711594],
        [106.891449865219, 48.0866348389267],
        [106.891833338838, 48.0867360989918],
        [106.891928179542, 48.0867997350198],
        [106.892036576627, 48.086967463078],
        [106.892053839113, 48.0871725498733],
        [106.891980781788, 48.0875310196409],
        [106.891914071877, 48.0875987170072],
        [106.891798221211, 48.0876237892065],
        [106.891510015475, 48.0876661778519],
        [106.891399871907, 48.0877287985452],
        [106.891307756148, 48.087811392282],
        [106.891164155102, 48.0880084265477],
        [106.891102261061, 48.0881043347473],
        [106.891092478235, 48.0881913639403],
        [106.891130240768, 48.0882776098239],
        [106.891128850416, 48.0883099764243],
        [106.891115640275, 48.0883613564915],
        [106.891074085301, 48.0884350595304],
        [106.891038843568, 48.0884813287504],
        [106.890975344237, 48.0885318715487],
        [106.890867316773, 48.0886078948385],
        [106.890767319356, 48.0886704597739],
        [106.890661363032, 48.0887255081757],
        [106.890546748034, 48.0887768918401],
        [106.890378596395, 48.0888405782301],
        [106.890253249788, 48.088909271146],
        [106.890218913672, 48.0889802744202],
        [106.890230222647, 48.0890562374555],
        [106.890291880166, 48.0891104306019],
        [106.890370772293, 48.0891890889053],
        [106.89047720346, 48.0893601003884],
        [106.890505041974, 48.0895381166908],
        [106.890459941873, 48.0897030559513],
        [106.890381753915, 48.0897744234509],
        [106.890283718819, 48.0898373130416],
        [106.890212786591, 48.0899128444023],
        [106.890171356623, 48.0899938400438],
        [106.890163301395, 48.0901495423676],
        [106.890159810227, 48.0902117682585],
        [106.890158603337, 48.0902757415323],
        [106.890157471091, 48.0903268688899],
        [106.89012311429, 48.0904468141692],
        [106.890014099371, 48.09076545746],
        [106.889982004366, 48.0908480278143],
        [106.889812136821, 48.0910883914162],
        [106.889679688267, 48.0912464112929],
        [106.889673165484, 48.0913044301554],
        [106.889683718129, 48.0913563776948],
        [106.889730654646, 48.0914569515771],
        [106.889755555075, 48.0915463046183],
        [106.889789099787, 48.0916355164659],
        [106.889814636037, 48.0917422336172],
        [106.88979482667, 48.0917917844633],
        [106.889722936664, 48.0918364007294],
        [106.889641762957, 48.0918637967768],
        [106.889568811751, 48.0918794728594],
        [106.889439031486, 48.0918787138316],
        [106.889135182942, 48.091848963359],
        [106.889023009604, 48.0918565995025],
        [106.888911788648, 48.0918902791132],
        [106.888775696941, 48.0919533242865],
        [106.888636552935, 48.0920511669279],
        [106.888112059324, 48.0923305907842],
        [106.887837535874, 48.0923930145261],
        [106.887382302651, 48.092516276505],
        [106.887182329401, 48.0925717251051],
        [106.887061933561, 48.0925910767169],
        [106.886957873007, 48.0925840988771],
        [106.886887598184, 48.0925534257001],
        [106.886817219039, 48.0925227057583],
        [106.886745573649, 48.0925037210699],
        [106.886660558938, 48.0925101143504],
        [106.886558501174, 48.0925443290576],
        [106.886482488676, 48.0925944230942],
        [106.886440939098, 48.0926529311879],
        [106.886435348013, 48.0927622491785],
        [106.886485105703, 48.0928892199616],
        [106.886564248741, 48.0930135656236],
        [106.886654234905, 48.0931429690728],
        [106.886770726788, 48.0932395733476],
        [106.886832978759, 48.0933261672688],
        [106.886807583703, 48.0934119688873],
        [106.886713082942, 48.0934504059115],
        [106.886570005302, 48.0934717935884],
        [106.886464593067, 48.0935032698601],
        [106.886365201793, 48.0935536849546],
        [106.88633266522, 48.0935988381159],
        [106.886261934441, 48.0936559216835],
        [106.88613458954, 48.0937109691859],
        [106.886043148273, 48.0937439913922],
        [106.885932858115, 48.0937586521401],
        [106.885852752802, 48.0937828124269],
        [106.885781950077, 48.0938282362841],
        [106.885736760044, 48.0938746673821],
        [106.885731727437, 48.0939118723351],
        [106.885712410899, 48.0939664458948],
        [106.885679228614, 48.0940294757797],
        [106.885655377694, 48.0941067104564],
        [106.885640660288, 48.0941704894765],
        [106.885641906749, 48.0942281045435],
        [106.885680721488, 48.0943432915097],
        [106.88573050346, 48.0943913953467],
        [106.885783850344, 48.0944429444863],
        [106.885908485588, 48.0945393482124],
        [106.885928043145, 48.0945713838623],
        [106.885963999839, 48.0947046490004],
        [106.885875375248, 48.0949376840269],
        [106.885826219205, 48.0950240387285],
        [106.885789981023, 48.0950897333046],
        [106.885782801735, 48.0951087629591],
        [106.885779665799, 48.0951258482793],
        [106.885781113707, 48.0951514007166],
        [106.885788956695, 48.0951797770251],
        [106.885803191164, 48.0952110824256],
        [106.885824296454, 48.0952463691247],
        [106.88584022075, 48.0952666659239],
        [106.885860852996, 48.0952861506354],
        [106.885886412628, 48.0953050390963],
        [106.885917421252, 48.0953237180152],
        [106.885981038394, 48.0953547554177],
        [106.886138018655, 48.0954213735976],
        [106.886173803578, 48.0954388231432],
        [106.886204015403, 48.0954556980221],
        [106.886337942442, 48.0955372620351],
        [106.886420232208, 48.0955936099572],
        [106.886461801571, 48.0956261690125],
        [106.886504895285, 48.0956628829357],
        [106.886607286697, 48.0957589467181],
        [106.886672621544, 48.0958274345885],
        [106.886827448828, 48.0960045740519],
        [106.88676767269, 48.0960774317281],
        [106.88666269213, 48.0961220066254],
        [106.88651613771, 48.0961958319721],
        [106.886341927338, 48.0963879505435],
        [106.886285049715, 48.096581713975],
        [106.886159802933, 48.0966551885861],
        [106.885993633399, 48.0967757570955],
        [106.886076051768, 48.0969886589995],
        [106.886100783125, 48.0972275036464],
        [106.88616045584, 48.09740149908],
        [106.886327202738, 48.0975880193716],
        [106.886333340611, 48.0977557510271],
        [106.886290094013, 48.0978850141821],
        [106.886086497394, 48.0980026257207],
        [106.886064037725, 48.0981172641005],
        [106.88614708562, 48.098201602522],
        [106.886413884793, 48.0983543415796],
        [106.886455819281, 48.0984896454808],
        [106.886393316398, 48.0986517635681],
        [106.886369864778, 48.0986993323084],
        [106.886344331226, 48.0987407209076],
        [106.886296032236, 48.0988049351997],
        [106.886248016533, 48.0988568197865],
        [106.886218012451, 48.0988836249793],
        [106.886182920006, 48.0989113070112],
        [106.886132892519, 48.0990768353278],
        [106.885854622493, 48.0990990494816],
        [106.885822078726, 48.099111873814],
        [106.885783927686, 48.0991243087399],
        [106.885649707468, 48.0991603256886],
        [106.885600577505, 48.0991752022738],
        [106.885554468364, 48.099192904529],
        [106.885516849723, 48.0992123748513],
        [106.885456305564, 48.0992535161369],
        [106.885430968964, 48.099274303966],
        [106.885409249437, 48.0992949766819],
        [106.885383689806, 48.0993252460633],
        [106.885361171681, 48.0993599751828],
        [106.885341516997, 48.0993994059579],
        [106.885324212243, 48.0994445717097],
        [106.885315877326, 48.0994772269925],
        [106.885311499426, 48.0995143671943],
        [106.885311499426, 48.0996468697073],
        [106.885312028228, 48.0996876746465],
        [106.885320394621, 48.0998140177028],
        [106.885317814466, 48.0998540627149],
        [106.885310312321, 48.0998893970781],
        [106.88529895928, 48.0999213221114],
        [106.885283270607, 48.0999556555291],
        [106.88523532595, 48.1000388266306],
        [106.885198984346, 48.1000946691337],
        [106.885166842576, 48.1001385020903],
        [106.885134365359, 48.1001764975474],
        [106.885100772982, 48.1002094433112],
        [106.885069683419, 48.1002345568793],
        [106.88503135971, 48.100260769419],
        [106.884884582258, 48.1003477167737],
        [106.884840138662, 48.1003736972884],
        [106.884696085256, 48.1004525597379],
        [106.884653368358, 48.1004801734213],
        [106.88461887666, 48.1005070109898],
        [106.884579021405, 48.1005437815703],
        [106.884544729356, 48.1005800575237],
        [106.884516156995, 48.100615676972],
        [106.884493386161, 48.1006505328958],
        [106.884478694836, 48.1006787104542],
        [106.884466093535, 48.1007086048183],
        [106.884447563005, 48.1007725376226],
        [106.884443631169, 48.1008068179803],
        [106.884444374009, 48.1008774246535],
        [106.884442436869, 48.1009073486952],
        [106.884435713537, 48.1009467551887],
        [106.884425350649, 48.1009897922452],
        [106.88438926895, 48.1011035735711],
        [106.884372312232, 48.1011485585592],
        [106.884350408345, 48.1011976975158],
        [106.884250033213, 48.1013919915472],
        [106.884211839905, 48.1014769819772],
        [106.884151972935, 48.1016360468661],
        [106.884134051246, 48.1016944956045],
        [106.884121174752, 48.1017479216293],
        [106.884103265653, 48.1018597469298],
        [106.884099337415, 48.1019098220807],
        [106.884098650333, 48.1019571165278],
        [106.884101152246, 48.1020148835801],
        [106.884106327845, 48.1020648849865],
        [106.884114515273, 48.1021103250315],
        [106.884125890797, 48.1021520238968],
        [106.884141085743, 48.1021909924204],
        [106.884162656881, 48.1022336661508],
        [106.884244327913, 48.1023656425604],
        [106.884277539877, 48.1024162348214],
        [106.88435866592, 48.1025308741006],
        [106.884393164813, 48.102585499821],
        [106.88445069984, 48.1026789204959],
        [106.884462886553, 48.1027070198132],
        [106.884468937192, 48.1027324571372],
        [106.884469421926, 48.1027562981647],
        [106.884465097986, 48.1027832220681],
        [106.884434148717, 48.1028812256881],
        [106.884416295376, 48.1029671532116],
        [106.884408500952, 48.1029901317892],
        [106.884398621, 48.103009799063],
        [106.884376089385, 48.1030392104912],
        [106.884343136427, 48.1030696714283],
        [106.884305773193, 48.10309768531],
        [106.884213063882, 48.1031610416488],
        [106.884169283985, 48.1031893945749],
        [106.884045244992, 48.1032602080922],
        [106.88401245571, 48.1032833881179],
        [106.88398705346, 48.1033062111128],
        [106.883966307, 48.1033296087745],
        [106.883946688289, 48.1033555218399],
        [106.883910581408, 48.103415245817],
        [106.883896669796, 48.1034447966401],
        [106.883884594598, 48.1034768925446],
        [106.883865245685, 48.1035507160927],
        [106.883860008932, 48.103593244133],
        [106.883860698712, 48.1036410206166],
        [106.883865639588, 48.103686645922],
        [106.883881907424, 48.1037941256984],
        [106.883886125245, 48.103846772011],
        [106.883886189996, 48.1040034869714],
        [106.883878327223, 48.1041837147067],
        [106.883870145191, 48.1043374610051],
        [106.883864713286, 48.1043845629972],
        [106.883857031277, 48.1044265721286],
        [106.883840308384, 48.1044801492395],
        [106.883789869007, 48.1046007950907],
        [106.883780669842, 48.1046301210833],
        [106.883774936664, 48.1046569532559],
        [106.883767716907, 48.1047368715095],
        [106.883770790789, 48.1048186918292],
        [106.883778310021, 48.1048845329948],
        [106.88378726547, 48.1049308426843],
        [106.883800312834, 48.1049713904174],
        [106.883817887386, 48.1050065377216],
        [106.88384232916, 48.1050404556525],
        [106.883875342373, 48.1050759500951],
        [106.88391741086, 48.105113699138],
        [106.883974321758, 48.1051589071579],
        [106.884031596881, 48.1052009495642],
        [106.88408260283, 48.1052342172853],
        [106.884131781357, 48.1052615935478],
        [106.884180029984, 48.1052835226165],
        [106.884223508608, 48.1052992706449],
        [106.884272768973, 48.1053138225749],
        [106.8843284469, 48.1053273897473],
        [106.884393329389, 48.1053406520495],
        [106.884462833493, 48.1053507334497],
        [106.884542301186, 48.105356386588],
        [106.884618462972, 48.1053580926019],
        [106.884787224351, 48.1053581177829],
        [106.884856688885, 48.1053599955674],
        [106.884980339371, 48.1053632322274],
        [106.88525721365, 48.1053642079918],
        [106.885374824289, 48.1053680148221],
        [106.885446572202, 48.1053730069588],
        [106.885512681365, 48.105380103509],
        [106.885574481877, 48.1053894519617],
        [106.885632634738, 48.1054011530408],
        [106.885711431537, 48.1054186520492],
        [106.88575448658, 48.1054328334586],
        [106.885797570402, 48.1054558821833],
        [106.885847168912, 48.1054919396014],
        [106.885888048495, 48.1055291004877],
        [106.885930783379, 48.1055781387202],
        [106.885973948139, 48.1056355847145],
        [106.885986504474, 48.1056576702653],
        [106.885994790827, 48.1056781325398],
        [106.885999785662, 48.1056994410764],
        [106.886002043859, 48.1057229646432],
        [106.885998486141, 48.1057791165131],
        [106.885992442697, 48.1058160867431],
        [106.885985122216, 48.1058438002512],
        [106.885975135244, 48.1058675072797],
        [106.885962221879, 48.1058874938128],
        [106.88594221646, 48.1059079497921],
        [106.88591431949, 48.1059286036222],
        [106.885878645183, 48.1059496675432],
        [106.88582469935, 48.1059773225954],
        [106.885789026842, 48.1059935787407],
        [106.885747435895, 48.1060095408077],
        [106.885626128143, 48.1060479454564],
        [106.885505118966, 48.1060806322155],
        [106.885356946666, 48.106112990722],
        [106.885274188353, 48.1061269041334],
        [106.885086795719, 48.1061515266717],
        [106.88500685858, 48.1061658897441],
        [106.884936799594, 48.106182153084],
        [106.884863217963, 48.1062015577558],
        [106.884698207656, 48.106251790288],
        [106.884577606771, 48.1062885275935],
        [106.884545243768, 48.1063015479781],
        [106.884519490782, 48.1063153480749],
        [106.884483117702, 48.1063429392753],
        [106.884450680954, 48.1063772744917],
        [106.884423628448, 48.1064168626481],
        [106.884404038516, 48.1064587036063],
        [106.884395368152, 48.1064940100906],
        [106.884393502958, 48.1065337151589],
        [106.884398426746, 48.1065778754686],
        [106.884410193476, 48.1066270108279],
        [106.884425993665, 48.1066680154166],
        [106.884450161146, 48.1067116846966],
        [106.884483039461, 48.1067587929839],
        [106.884527658425, 48.1068137010915],
        [106.884555002312, 48.1068434218865],
        [106.884588176503, 48.1068752911618],
        [106.884694151714, 48.1069659050525],
        [106.884725549744, 48.1069901076074],
        [106.884823954462, 48.1070587861341],
        [106.884850625656, 48.10708205879],
        [106.884870205696, 48.1071044797879],
        [106.884892656371, 48.1071393896711],
        [106.884909789355, 48.1071753814388],
        [106.884920886989, 48.1072109415318],
        [106.884925636309, 48.1072450330319],
        [106.884922467998, 48.1072878758349],
        [106.884908979966, 48.1073396138321],
        [106.884899068537, 48.1073630960301],
        [106.884884017484, 48.1073882824433],
        [106.884810495208, 48.1074823209524],
        [106.884784952663, 48.1075235296872],
        [106.884757529636, 48.1075868482545],
        [106.88473912591, 48.107645534414],
        [106.884723956146, 48.1077225379648],
        [106.884722153005, 48.1077529197615],
        [106.884723945354, 48.1077805109618],
        [106.884730401587, 48.1078148057087],
        [106.884740060306, 48.107846523898],
        [106.88475281539, 48.1078753237872],
        [106.884768585902, 48.1079010318072],
        [106.88478920286, 48.1079257020096],
        [106.884816299433, 48.1079510790791],
        [106.884850201176, 48.1079775164493],
        [106.884893150998, 48.1080067686975],
        [106.884929735419, 48.1080282031391],
        [106.88497349553, 48.1080496492719],
        [106.885107940579, 48.1081042902808],
        [106.885221972816, 48.1081473174448],
        [106.88531169368, 48.1081750462414],
        [106.885362888487, 48.1081856879192],
        [106.885487359154, 48.1082039027879],
        [106.885518116868, 48.1082105649656],
        [106.885544618989, 48.1082183764769],
        [106.885601529887, 48.1082401346745],
        [106.885652043007, 48.108264104305],
        [106.885694805771, 48.1082896387559],
        [106.885729252503, 48.1083163908888],
        [106.885767078888, 48.1083563900355],
        [106.885781507611, 48.1083765231581],
        [106.885792522507, 48.1083961877339],
        [106.885800988725, 48.1084189037095],
        [106.885806060901, 48.1084446611922],
        [106.885807901813, 48.1084738918567],
        [106.885806763272, 48.1085104717809],
        [106.885801792719, 48.1085472054892],
        [106.885791154638, 48.1085862711395],
        [106.885774786977, 48.1086279358306],
        [106.885752362382, 48.1086730359319],
        [106.885730949524, 48.1087060248632],
        [106.885677311259, 48.1087730036712],
        [106.885656521631, 48.1088025994604],
        [106.885624459901, 48.1088563915093],
        [106.885601310452, 48.1089007154957],
        [106.885584076744, 48.1089413234834],
        [106.885572455704, 48.1089791228883],
        [106.885566820552, 48.1090110847938],
        [106.885564556959, 48.1090471664936],
        [106.885569300883, 48.1091677916603],
        [106.885571765025, 48.1092351149087],
        [106.885582951692, 48.1092876946714],
        [106.885601749321, 48.1093387132111],
        [106.88562744655, 48.1093862594684],
        [106.885659327516, 48.1094290312249],
        [106.885693499955, 48.1094638421826],
        [106.885734978487, 48.1094980335075],
        [106.885782738782, 48.1095307517428],
        [106.885835147674, 48.1095608709375],
        [106.885865168843, 48.1095753527204],
        [106.885900483421, 48.1095899541131],
        [106.886018801826, 48.10963195605],
        [106.886176478162, 48.1096823450642],
        [106.886232613844, 48.1097025447367],
        [106.88633363469, 48.1097467976766],
        [106.886437360696, 48.1098002272987],
        [106.886538392333, 48.1098599278934],
        [106.886622741546, 48.1099184368864],
        [106.886669385784, 48.1099565834296],
        [106.886737018399, 48.1100176051284],
        [106.886790742998, 48.1100687055064],
        [106.886924866989, 48.1102031361659],
        [106.887061111581, 48.1103329820815],
        [106.887153913522, 48.1104149355009],
        [106.887251136531, 48.1104899281677],
        [106.887454136, 48.1106311208296],
        [106.887536218022, 48.1106915795528],
        [106.887672314226, 48.1107914007026],
        [106.887706689013, 48.1108214317637],
        [106.887733136275, 48.1108500167149],
        [106.887754149834, 48.1108784505801],
        [106.887773554506, 48.1109099205564],
        [106.887791518464, 48.1109446838501],
        [106.887808439208, 48.1109835057842],
        [106.88782106569, 48.1110239779742],
        [106.887844024482, 48.1111311187062],
        [106.887873094168, 48.1112228738366],
        [106.887899961414, 48.1112851348012],
        [106.887920787914, 48.1113221392054],
        [106.887945420345, 48.1113599898717],
        [106.887973868599, 48.1113987056858],
        [106.888006162355, 48.1114383262178],
        [106.888034863318, 48.1114697431342],
        [106.888069468331, 48.1115035846228],
        [106.888183228973, 48.111603823058],
        [106.888303261486, 48.1117002447705],
        [106.888349255514, 48.1117425569735],
        [106.888392936485, 48.1117895879192],
        [106.888424285952, 48.1118275797791],
        [106.888448359904, 48.1118626740233],
        [106.888465512673, 48.1118955811162],
        [106.888476961942, 48.1119305728377],
        [106.888483185251, 48.1119707590433],
        [106.888484753669, 48.112012905771],
        [106.888482968514, 48.1120973826881],
        [106.888481524203, 48.1121567856072],
        [106.888477381926, 48.1122136110694],
        [106.888470527293, 48.112268002966],
        [106.888460952211, 48.1123200431355],
        [106.888445922741, 48.1123735276163],
        [106.888422602421, 48.1124319682608],
        [106.888394314246, 48.1124901274175],
        [106.88831264861, 48.1126447982189],
        [106.888291231255, 48.1126915746565],
        [106.888274943634, 48.1127340154625],
        [106.888229414556, 48.1128673372578],
        [106.888218540853, 48.1129110649937],
        [106.888212467731, 48.1129506036875],
        [106.888209777859, 48.1129916541416],
        [106.888209872288, 48.1130325121408],
        [106.888212751018, 48.1130727954732],
        [106.888218389767, 48.1131121785842],
        [106.888228892949, 48.1131618292551],
        [106.888241481659, 48.1132052476241],
        [106.888256717973, 48.113244351046],
        [106.888274824024, 48.1132796584295],
        [106.888296778274, 48.1133119198093],
        [106.888326448707, 48.1133465041379],
        [106.888442337144, 48.1134587844954],
        [106.888530374477, 48.1135452426189],
        [106.888609111022, 48.113617714486],
        [106.888676331747, 48.1136743789695],
        [106.888837193482, 48.113802582723],
        [106.888973959681, 48.1139087027245],
        [106.889007765196, 48.1139390908164],
        [106.889034375236, 48.1139677477134],
        [106.889059869218, 48.114000793302],
        [106.889082846896, 48.114035481952],
        [106.889102986314, 48.1140713316267],
        [106.889119985299, 48.114107802733],
        [106.889138580581, 48.1141659735809],
        [106.889155577768, 48.1142554165543],
        [106.889162029504, 48.1143026426529],
        [106.889165503585, 48.1143554778231],
        [106.889165654671, 48.1145290487767],
        [106.889167920963, 48.1145920291988],
        [106.889173445498, 48.1147237268186],
        [106.889178100389, 48.1147608850069],
        [106.889185380401, 48.1147938307707],
        [106.889209808686, 48.1148658215005],
        [106.889224351623, 48.1148978877274],
        [106.889240585285, 48.1149276489919],
        [106.889263828263, 48.1149642837747],
        [106.889286810438, 48.1149956638189],
        [106.889310595708, 48.1150232298382],
        [106.889335510525, 48.1150473415616],
        [106.8893661864, 48.1150714658755],
        [106.889403745686, 48.1150958815697],
        [106.889448796325, 48.1151211210429],
        [106.889510370207, 48.1151522474783],
        [106.88960102097, 48.1151933698782],
        [106.889683996919, 48.1152234908715],
        [106.889723433989, 48.1152341118648],
        [106.889768867739, 48.1152431365615],
        [106.889939729035, 48.1152662941042],
        [106.890007931821, 48.1152787892847],
        [106.890148593883, 48.1153091270146],
        [106.890188653284, 48.1153216509734],
        [106.890221279788, 48.1153359061272],
        [106.890250126442, 48.1153525750614],
        [106.890277622315, 48.1153717818823],
        [106.890302829412, 48.1153928709842],
        [106.890324779165, 48.1154150374741],
        [106.890350669748, 48.1154514968891],
        [106.890378505564, 48.1155084626455],
        [106.890393693314, 48.1155475651681],
        [106.890405550876, 48.1155919305232],
        [106.890426872902, 48.1157299647661],
        [106.890431163567, 48.1157703677084],
        [106.890432310203, 48.1158156197951],
        [106.890424784676, 48.1159685908778],
        [106.890424550852, 48.1160261061199],
        [106.890429887429, 48.1160831348288],
        [106.890441696427, 48.1161338997597],
        [106.890469056502, 48.1162154125113],
        [106.890482140738, 48.1162433769303],
        [106.890496904908, 48.1162677170815],
        [106.890515077509, 48.1162913314798],
        [106.890537795283, 48.116316098809],
        [106.890601395338, 48.1163737777277],
        [106.890660777573, 48.1164180990161],
        [106.890766456007, 48.1164855796458],
        [106.890851459028, 48.1165382439448],
        [106.890951625517, 48.1165970488148],
        [106.891105583156, 48.1166751504379],
        [106.891139552349, 48.1166951594541],
        [106.891167202904, 48.1167147538828],
        [106.891193571027, 48.1167376470248],
        [106.891219980518, 48.1167648425235],
        [106.891293039642, 48.1168541452027],
        [106.891357719783, 48.1169321110282],
        [106.891375263757, 48.1169573657899],
        [106.89138822029, 48.1169805682986],
        [106.891400188468, 48.117012253213],
        [106.891407660935, 48.1170487746813],
        [106.891415744941, 48.1171822034959],
        [106.891427951439, 48.1173799626152],
        [106.891435685608, 48.1174513274169],
        [106.891452127913, 48.117566025152],
        [106.891461019511, 48.1176014755277],
        [106.891472521839, 48.1176326019631],
        [106.891488403867, 48.1176635377421],
        [106.89151010091, 48.1176971741853],
        [106.891589297009, 48.1177990871582],
        [106.891649737745, 48.1178759791931],
        [106.891694533876, 48.1179253429802],
        [106.891718892013, 48.1179463016805],
        [106.891789822442, 48.117998584667],
        [106.8918071236, 48.11801513579],
        [106.891819137643, 48.1180310726759],
        [106.891830676844, 48.1180548201739],
        [106.891838582784, 48.1180817899427],
        [106.891842842873, 48.1181119289224],
        [106.891843449915, 48.118145189449],
        [106.891838342665, 48.1181894226038],
        [106.891826308837, 48.1182263082976],
        [106.891808938432, 48.1182546684183],
        [106.891782724993, 48.1182840519675],
        [106.891747432898, 48.1183148321638],
        [106.891700054814, 48.1183496395243],
        [106.891665282527, 48.1183712178575],
        [106.891623093531, 48.1183927791035],
        [106.891574680327, 48.1184141137204],
        [106.89149237887, 48.1184473679517],
        [106.891443411684, 48.1184657195174],
        [106.891387260714, 48.1184839307888],
        [106.891177823898, 48.1185423264673],
        [106.891094415375, 48.1185684364842],
        [106.890977642904, 48.1186102729458],
        [106.890859515155, 48.1186557912318],
        [106.890739875645, 48.1187050506976],
        [106.890618487853, 48.1187581502685],
        [106.890457380604, 48.1188293406016],
        [106.89041057269, 48.1188532994403],
        [106.890371331672, 48.1188767339742],
        [106.890320725022, 48.1189114567983],
        [106.890278502751, 48.118944254174],
        [106.890243413903, 48.1189761018657],
        [106.890215157204, 48.1190072930522],
        [106.890199793186, 48.1190288857745],
        [106.890185669333, 48.1190540919728],
        [106.890140158242, 48.119156726202],
        [106.890085635943, 48.1192529635535],
        [106.890064911966, 48.1192994261277],
        [106.890055309005, 48.1193344115539],
        [106.890049263763, 48.1193741202195],
        [106.890042653746, 48.1195153542503],
        [106.890037240726, 48.11964088342],
        [106.890036887293, 48.1199157818879],
        [106.890031264731, 48.1200275010684],
        [106.890009741257, 48.120222625174],
        [106.889975952828, 48.120439324915],
        [106.889957820697, 48.1205530837578],
        [106.889942157205, 48.1206150245638],
        [106.889926880421, 48.1206557998253],
        [106.889906956841, 48.1206994798972],
        [106.889848527887, 48.1208051808145],
        [106.88977228966, 48.1209209532395],
        [106.889733349914, 48.1209815630488],
        [106.88971542103, 48.1210161959407],
        [106.889705784794, 48.1210450704736],
        [106.889699610948, 48.1210780459151],
        [106.889691924443, 48.1211984624392],
        [106.889678850998, 48.1213557017043],
        [106.88966652579, 48.1216030584345],
        [106.889659976027, 48.1219070922386],
        [106.889652169012, 48.1220344182539],
        [106.889637505566, 48.1221524380846],
        [106.88961484445, 48.1222833047308],
        [106.889587261343, 48.1224156975265],
        [106.889525304349, 48.1226899259993],
        [106.889460748315, 48.1230192469408],
        [106.889432383698, 48.1231466152242],
        [106.889394361261, 48.1232811340172],
        [106.889373156146, 48.1233421719037],
        [106.8893501362, 48.1234001179212],
        [106.889288699914, 48.1235464870808],
        [106.889264277924, 48.1235917922275],
        [106.889237870232, 48.1236309981721],
        [106.889195559827, 48.1236833414131],
        [106.889152818648, 48.123728820129],
        [106.889108749169, 48.1237683795072],
        [106.889063051019, 48.1238022794517],
        [106.889023950295, 48.1238266052137],
        [106.8889808314, 48.123850035251],
        [106.88893431127, 48.1238722305191],
        [106.888885267641, 48.1238927746319],
        [106.888837878765, 48.1239089318518],
        [106.888782235911, 48.123923383957],
        [106.888597792154, 48.1239588676077],
        [106.888536050998, 48.1239726155438],
        [106.888332431896, 48.1240222329398],
        [106.888232959683, 48.124048639733],
        [106.888138799766, 48.1240778901825],
        [106.88805808831, 48.1241084608368],
        [106.887939211426, 48.1241606970586],
        [106.887851105744, 48.1242055120748],
        [106.887813175937, 48.1242278701201],
        [106.887779322758, 48.1242502677357],
        [106.887749271012, 48.1242728901818],
        [106.887722871413, 48.1242958489743],
        [106.88767392671, 48.1243471714848],
        [106.887636075145, 48.1243983195269],
        [106.887618708337, 48.1244292705944],
        [106.887603796678, 48.1244631444586],
        [106.88759125833, 48.1245001182859],
        [106.887580926019, 48.1245406876027],
        [106.887574500363, 48.1245852121379],
        [106.887573673886, 48.124634785467],
        [106.887578089557, 48.1246898077884],
        [106.887589314895, 48.1247695848485],
        [106.887602068181, 48.1248362192162],
        [106.887621148197, 48.1249072296849],
        [106.887646877801, 48.1249839589426],
        [106.887680861383, 48.1250712138655],
        [106.887702373166, 48.1251167348495],
        [106.887731402382, 48.1251665240159],
        [106.887841849921, 48.1253268587476],
        [106.887878965842, 48.125385731966],
        [106.887908786461, 48.1254441465302],
        [106.887927933927, 48.1254982767242],
        [106.887948321558, 48.1255841502884],
        [106.887952556465, 48.12561658164],
        [106.887953473774, 48.1256460560207],
        [106.887946649718, 48.1257037097585],
        [106.88792799598, 48.1257744639204],
        [106.8879030308, 48.1258422116488],
        [106.887872352227, 48.1259033682459],
        [106.887858564721, 48.1259239762106],
        [106.887840085452, 48.1259461561902],
        [106.887748637889, 48.1260401830081],
        [106.887730457195, 48.1260646589569],
        [106.887718125691, 48.126087781426],
        [106.887708373443, 48.1261153978074],
        [106.887701106921, 48.1261461860977],
        [106.887692893412, 48.1262229225499],
        [106.887693242349, 48.1262744689916],
        [106.887699724663, 48.1263293231398],
        [106.887712380822, 48.1263878977833],
        [106.887731452744, 48.1264513224706],
        [106.887745173701, 48.1264864356006],
        [106.887664200542, 48.1265221198],
        [106.88756849469, 48.1265195990003],
        [106.887460000479, 48.1264978704804],
        [106.887327671535, 48.1264949998444],
        [106.887146244104, 48.1264908413793],
        [106.887063573026, 48.1264172399637],
        [106.886967139622, 48.126404546033],
        [106.886917546508, 48.1264382472274],
        [106.886917254228, 48.1264981717533],
        [106.886936774912, 48.126574999037],
        [106.887013067099, 48.1266394237704],
        [106.887063635978, 48.1267099351155],
        [106.887003485722, 48.1268144381358],
        [106.886895671398, 48.1270732099607],
        [106.88680943181, 48.1273387671704],
        [106.886694718786, 48.1275548185001],
        [106.886828484847, 48.1277132484677],
        [106.886916648085, 48.1278533925201],
        [106.886932011203, 48.1280649247565],
        [106.887017711199, 48.1282982466668],
        [106.887075763336, 48.128500157956],
        [106.885844853157, 48.1285416742589],
        [106.885489781928, 48.1286642455585],
        [106.885278748815, 48.1289681390684],
        [106.885065515961, 48.1290906195365],
        [106.884232124113, 48.1292649162429],
        [106.882650907314, 48.1297667658237],
        [106.881275414929, 48.1304301246506],
        [106.880179797859, 48.1310051187913],
        [106.879143985706, 48.1318552731024],
        [106.877777348946, 48.1328012870498],
        [106.874708266773, 48.1344606864116],
        [106.871248173764, 48.1369979050294],
        [106.869779178866, 48.1383785199528],
        [106.868305526379, 48.1399575981647],
        [106.867694919085, 48.140834985746],
        [106.867475780383, 48.1412903673566],
        [106.867408275472, 48.1417816696884],
        [106.867249999288, 48.1426666655342],
        [106.87008333228, 48.172722223252],
        [106.875222221229, 48.1853611109266],
        [106.96094444483, 48.1913333332667],
        [106.968694444293, 48.199666667183],
        [107.001527777585, 48.1304166671955],
        [107.025166667108, 48.0992499997877],
        [107.025518182418, 48.0982890391079],
        [107.028230732862, 48.0908723958444],
        [107.028926039205, 48.0851284358287],
        [107.031943474212, 48.0815479083093],
        [107.031901404826, 48.0771396600673],
        [107.032167742647, 48.0730670801817],
        [107.032693855937, 48.0691170077438],
        [107.032744994986, 48.0660891388028],
        [107.033165633987, 48.0616269132515],
        [107.033192667608, 48.0564826922225],
      ],
    ],
  },
};
